module.exports={
    "candidates": [
        {
            "name": "Ellen Copeland",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.754241499021538,
                8.215416845610195,
                5.501666625056007,
                7.6831472173048105
            ]
        },
        {
            "name": "Todd Howe",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                7.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Rebeka Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.779380624701336,
                9.581508108394107,
                0.32233209543052965,
                5.333374507215124
            ]
        },
        {
            "name": "David Goodwin",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                1.0,
                3.0
            ]
        },
        {
            "name": "Jennifer White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.764917201932253,
                5.020854939012129,
                4.9866759896119826,
                9.120115275075285
            ]
        },
        {
            "name": "Corey Chang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.5116499533727255,
                3.374746563541719,
                9.663894776677637,
                7.384404611043669
            ]
        },
        {
            "name": "Karen Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.480675075347557,
                3.824820906881974,
                5.834975570363834,
                9.392084846326345
            ]
        },
        {
            "name": "Ashley Morgan",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.224701947746072,
                3.7879299062218714,
                5.926540825377145,
                6.602626856018188
            ]
        },
        {
            "name": "James Price",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                6.0,
                5.0,
                7.0
            ]
        },
        {
            "name": "David Dorsey",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.0834781522929284,
                5.866094243349329,
                4.349643114190123,
                4.995804987112102
            ]
        },
        {
            "name": "John Forbes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.669481140528737,
                5.0865234278461635,
                8.152909491614162,
                8.209200524029459
            ]
        },
        {
            "name": "Vincent Mclean",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                3.0,
                1.0,
                4.0
            ]
        },
        {
            "name": "Brian Cook",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.539037392656034,
                2.282870680249958,
                7.666318529477543,
                7.106511229518406
            ]
        },
        {
            "name": "Lindsay Lin",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.0514624059242454,
                6.679283951949564,
                6.27202056767147,
                2.566770889476327
            ]
        },
        {
            "name": "Jill Chen",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Amy Espinoza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.038592552484651,
                6.425786558634402,
                1.4093597898974402,
                9.503887092535564
            ]
        },
        {
            "name": "Amy Rodriguez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                1.0,
                7.0,
                8.0
            ]
        },
        {
            "name": "Leah Gregory",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.465142169048541,
                7.783844414276082,
                4.0535607107782825,
                1.0991011164503253
            ]
        },
        {
            "name": "Keith Alvarado",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.446206576018687,
                7.434448143574782,
                0.9061103789785001,
                1.3753575286260573
            ]
        },
        {
            "name": "Nicole Wells",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                8.0,
                5.0,
                0.0
            ]
        },
        {
            "name": "Erica Mcdonald",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.281856819727928,
                6.230519526648401,
                9.002862379391583,
                4.230401437918648
            ]
        },
        {
            "name": "Zachary Hunt",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.20093126929678,
                8.261034212184375,
                8.70637951244388,
                5.257453137561963
            ]
        },
        {
            "name": "James Stephens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.421256873501846,
                6.155587731866254,
                2.7062040402003307,
                5.002403074106919
            ]
        },
        {
            "name": "James Bell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.507536250368143,
                3.1296311032139275,
                7.858422212618202,
                4.013207583232292
            ]
        },
        {
            "name": "Amber Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.497829191484342,
                7.1231147820218546,
                3.658786773094191,
                5.847675771955288
            ]
        },
        {
            "name": "Dillon Harris",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.113703470956706,
                1.026657868972449,
                3.17774789320818,
                8.266461725922222
            ]
        },
        {
            "name": "Pamela Fleming",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                9.0,
                3.0
            ]
        },
        {
            "name": "Brandon Perry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.527196461379798,
                7.898908135336117,
                4.03766778113824,
                3.5097035479612644
            ]
        },
        {
            "name": "Anna Luna",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.0060207665608765,
                8.376330109604847,
                3.8779281387422686,
                0.6025049652213605
            ]
        },
        {
            "name": "Gabriel Cooley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.275068430364551,
                3.08386083817683,
                6.853554955178428,
                7.8953530996055985
            ]
        },
        {
            "name": "Andrew Velez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                2.0,
                8.0,
                1.0
            ]
        },
        {
            "name": "Eric Shea",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                0.0,
                2.0,
                9.0
            ]
        },
        {
            "name": "Jill Beasley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.682041608431895,
                9.057355138146212,
                7.594422272367197,
                5.896166934911616
            ]
        },
        {
            "name": "Jeremy Powell",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.055901679709812,
                7.027007755726955,
                1.548055186756622,
                5.179733838720365
            ]
        },
        {
            "name": "Geoffrey Baker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.496597204851907,
                4.864313179449292,
                3.0540496773927472,
                6.355680905022474
            ]
        },
        {
            "name": "Jeremy Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.752771600937022,
                2.944995747920234,
                7.479855270239084,
                8.444393638019976
            ]
        },
        {
            "name": "Lisa Downs",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.132071749622646,
                3.4637282839256356,
                7.188673918432874,
                4.827098932738007
            ]
        },
        {
            "name": "Terrence Lloyd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.542940339636286,
                6.573561251208208,
                8.370120368328012,
                2.588507815657957
            ]
        },
        {
            "name": "Daniel Harris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.736874178167858,
                8.403016330778371,
                3.214770943262815,
                2.561326669060206
            ]
        },
        {
            "name": "Beth Hayes DDS",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.347630840012629,
                0.7171581626278162,
                6.630122501120259,
                7.192870751263616
            ]
        },
        {
            "name": "Amy Shaffer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7317678960563008,
                5.642139667525345,
                2.0074506757490034,
                9.677387718610845
            ]
        },
        {
            "name": "Thomas Nelson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                7.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "George Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.12449099326113028,
                2.150464607883168,
                7.509368787982591,
                8.556215481811119
            ]
        },
        {
            "name": "Gregory White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.2706099894210325,
                7.490173074218866,
                5.984722823014743,
                3.623036157455451
            ]
        },
        {
            "name": "Makayla Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.38033552835099,
                5.990751136834999,
                6.774317221404399,
                1.6549848774416833
            ]
        },
        {
            "name": "Angela Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.911923750046821,
                2.939659225685765,
                3.5170551996646533,
                6.686649573687565
            ]
        },
        {
            "name": "Anthony Price",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.8947575133553465,
                6.087473586781406,
                3.492351522402789,
                7.779617295039163
            ]
        },
        {
            "name": "Debbie Moreno",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.563798839869479,
                7.507914032828173,
                9.348960486708702,
                9.806082693981573
            ]
        },
        {
            "name": "Gerald Cox",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.312866690253452,
                8.514746487548061,
                4.358003362917101,
                6.700052840602801
            ]
        },
        {
            "name": "Mary Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.286398203582065,
                8.10967521242594,
                0.04787098084730917,
                7.72577265156854
            ]
        },
        {
            "name": "Kathy Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.886228281294006,
                2.667528080775561,
                1.2849789586175566,
                8.412963942570052
            ]
        },
        {
            "name": "Roger Butler",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                8.0,
                6.0,
                4.0,
                8.0
            ]
        },
        {
            "name": "Jason Gardner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.9399274955265824,
                5.869775613189417,
                8.399306213841172,
                9.139603440523414
            ]
        },
        {
            "name": "John Smith",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                3.0,
                7.0
            ]
        },
        {
            "name": "Abigail Haney",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.098363373952554,
                8.141327923030625,
                7.254209341969755,
                4.906744017984847
            ]
        },
        {
            "name": "Aaron Allen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.892767321694658,
                5.755712631817895,
                7.959731377485019,
                5.7320648355973605
            ]
        },
        {
            "name": "David Campbell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.581037983812346,
                1.9962708936843057,
                4.05957352920515,
                6.183920860931408
            ]
        },
        {
            "name": "David Norton",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                3.0,
                7.0,
                9.0
            ]
        },
        {
            "name": "Tammy Avila",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.9604836694018495,
                2.907982725334745,
                3.5795002442882207,
                5.178514043366857
            ]
        },
        {
            "name": "Tamara Smith",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                2.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Sean Glenn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.622566514659688,
                3.794424802160555,
                9.708745019989028,
                3.744235706107777
            ]
        },
        {
            "name": "Brenda Warner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.3001065096272437,
                2.5201586162200784,
                6.341875636339758,
                7.58035069064237
            ]
        },
        {
            "name": "Daniel Coleman",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                2.0,
                8.0
            ]
        },
        {
            "name": "Steven Key",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.192162709239758,
                9.927709752389177,
                5.201927218495931,
                8.067594971669173
            ]
        },
        {
            "name": "Michael Snyder",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                1.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Misty Hicks",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                6.0,
                3.0
            ]
        },
        {
            "name": "April Gross",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.78431641005292,
                4.348503293775777,
                5.014870932268565,
                0.9942459496264545
            ]
        },
        {
            "name": "Carlos Weaver",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.775967630766018,
                8.047036081650674,
                4.369269808597077,
                4.850005988490696
            ]
        },
        {
            "name": "Devon Cruz",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                6.0,
                9.0,
                4.0,
                7.0
            ]
        },
        {
            "name": "Martha Young",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.491670885942016,
                8.494423227991891,
                7.05667319571015,
                1.922512541744911
            ]
        },
        {
            "name": "Lauren Cook",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.93895956595788,
                4.309968673663867,
                6.864349018262894,
                3.601369925981638
            ]
        },
        {
            "name": "Karla Mccoy",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.1639104865934659,
                1.5689737517420224,
                2.737210419268626,
                8.79472363671043
            ]
        },
        {
            "name": "Daniel Hood",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.829328157755069,
                5.319118078899815,
                6.065448867829578,
                8.641127501471896
            ]
        },
        {
            "name": "Christopher Le",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                1.0,
                8.0,
                7.0
            ]
        },
        {
            "name": "Blake Wallace",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.282830553488434,
                7.016438112053121,
                5.500849082179881,
                9.782687974425613
            ]
        },
        {
            "name": "Louis Walters",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                9.522604488478143,
                1.4652376373324405,
                2.780230411450108,
                2.282407835018836
            ]
        },
        {
            "name": "Jacob Campbell",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.46484067294594,
                5.823674346089041,
                3.9131645820756074,
                9.069910906412893
            ]
        },
        {
            "name": "Michele Durham",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.322057429715337,
                1.0537630936908509,
                9.224242595737698,
                9.491151632057155
            ]
        },
        {
            "name": "Stephanie Ford",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.650890084408525,
                6.210254849553297,
                2.4303900476479847,
                2.707185290937004
            ]
        },
        {
            "name": "Martin Martin",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                6.0,
                3.0
            ]
        },
        {
            "name": "Sonia Flores",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.6876334748841142,
                6.890327375161862,
                3.009290959294157,
                9.986441490355956
            ]
        },
        {
            "name": "Susan Ewing",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.701672420428809,
                3.2541126324099197,
                7.143009050751882,
                4.801489135368941
            ]
        },
        {
            "name": "Debbie Page",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Sheri Anthony",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.418316282737112,
                3.012486674897775,
                3.2784898838706713,
                5.204585728887391
            ]
        },
        {
            "name": "Lauren Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.311988562548635,
                8.227524140303323,
                8.181453422328818,
                6.6117624160733275
            ]
        },
        {
            "name": "Alexis Pena",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.3483968309175833,
                7.124242552069312,
                0.8066480771888855,
                4.680339295989802
            ]
        },
        {
            "name": "Emily Delacruz",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                9.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Danny Stevens",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.391315429155253,
                9.672703138838598,
                8.921815330051857,
                2.9093837587029796
            ]
        },
        {
            "name": "Justin Rogers",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.358422916187006,
                9.821781412980506,
                7.362996004801163,
                6.340719007164388
            ]
        },
        {
            "name": "Paula Mcclure",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                3.0,
                4.0
            ]
        },
        {
            "name": "Sarah Owen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.36436214708627,
                4.809716379219617,
                8.311364502278213,
                3.503338892563292
            ]
        },
        {
            "name": "Jackson Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.4150254243650475,
                9.626695803441113,
                7.066318521617321,
                7.014261985328517
            ]
        },
        {
            "name": "Blake Bruce",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.19033907969836,
                7.3238019882890235,
                8.128779384007807,
                7.725830580444536
            ]
        },
        {
            "name": "Katrina Woods",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.8225539652213909,
                4.197558143228888,
                8.802336346849986,
                9.542011090661852
            ]
        },
        {
            "name": "Steven White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.467880193480092,
                4.905247949962681,
                9.21102548778698,
                9.853163893521298
            ]
        },
        {
            "name": "Nicole Cruz",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                9.0,
                0.0
            ]
        },
        {
            "name": "Ryan Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.870802928033592,
                9.837680169585216,
                1.7604662685881876,
                8.178012572736149
            ]
        },
        {
            "name": "Tina Hardy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.753051866820208,
                5.457180684445758,
                8.550623191807814,
                5.771386953214128
            ]
        },
        {
            "name": "Dustin Solomon",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                0.0,
                8.0,
                3.0
            ]
        },
        {
            "name": "Ryan Herrera",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.4254057993161684,
                8.200689916529932,
                4.357796546675309,
                5.777306228819377
            ]
        },
        {
            "name": "Katrina Wang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.140013578983234,
                1.3589275918636319,
                4.257221641271711,
                8.416430703334603
            ]
        },
        {
            "name": "Anita Brown",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                8.04300053878025,
                2.576324816986917,
                5.4468348113322085,
                0.9780395307544166
            ]
        },
        {
            "name": "Michael Mckee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.150373568222903,
                4.811471389897796,
                5.278203708273144,
                6.8339407261441965
            ]
        },
        {
            "name": "Ellen Wheeler",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.636697191751544,
                5.040487690848119,
                8.926149860297064,
                4.256857949819358
            ]
        },
        {
            "name": "Joel Mcgee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.323942780273098,
                9.167084078523075,
                7.473792749615694,
                9.235030766237761
            ]
        },
        {
            "name": "Lauren Carlson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.632165769510376,
                0.848010808218336,
                8.63523422547549,
                6.8144917998866354
            ]
        },
        {
            "name": "Kim Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7250354246057116,
                7.744675408356305,
                7.766668326736586,
                4.0874180822446835
            ]
        },
        {
            "name": "Susan Bailey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.139111490093134,
                2.0766204988688832,
                3.6472632963949323,
                7.591088247798461
            ]
        },
        {
            "name": "Brenda Morales",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                3.0,
                8.0,
                6.0,
                9.0
            ]
        },
        {
            "name": "Cynthia Harvey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.4458400939856708,
                1.6823393355706657,
                9.203164890724642,
                5.8351611728437796
            ]
        },
        {
            "name": "John Boyd",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.735108767706417,
                8.174925095233435,
                1.0759220061806694,
                2.743193768493408
            ]
        },
        {
            "name": "Hannah Bowers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                6.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "Jessica Casey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.2022271770156463,
                9.34181049865667,
                7.519415973373526,
                6.8983131102515705
            ]
        },
        {
            "name": "Pamela Long",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.132661733654493,
                8.454344211286147,
                1.2682251776568363,
                0.4205942916794137
            ]
        },
        {
            "name": "Brian Zhang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.942540501641009,
                6.72930705175442,
                3.3475043245540768,
                0.6032080329983764
            ]
        },
        {
            "name": "Daniel Cook",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2502831431701966,
                5.039995486271046,
                8.842001531559339,
                8.364425234453565
            ]
        },
        {
            "name": "Patrick Floyd",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                1.0,
                5.0
            ]
        },
        {
            "name": "Sara Quinn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.047524508786356,
                9.895239152243192,
                3.5725996445952353,
                7.0864216128753075
            ]
        },
        {
            "name": "Linda Norton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.8401764556259055,
                9.04823264488919,
                8.103565958062998,
                6.730659611660519
            ]
        },
        {
            "name": "Mike Hodges",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                0.0,
                5.0,
                0.0
            ]
        },
        {
            "name": "Ryan Gutierrez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                4.0,
                4.0
            ]
        },
        {
            "name": "Corey Harper",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.860797697511143,
                0.30502058342484395,
                9.672588434847881,
                2.8112893431685397
            ]
        },
        {
            "name": "Michael Curry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.569771172504771,
                8.05113411710674,
                7.614953073720163,
                1.7760618433181872
            ]
        },
        {
            "name": "Blake Callahan",
            "city": 1,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                7.0,
                6.0,
                9.0,
                4.0
            ]
        },
        {
            "name": "Tracy Velez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.698554547133723,
                2.5595946959784275,
                1.1209371457842967,
                1.8907754140209223
            ]
        },
        {
            "name": "Ashley Dunn",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                5.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Mark York",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Xavier Kelley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.47235850858847,
                6.897067819993428,
                4.956607081692908,
                9.342833602207266
            ]
        },
        {
            "name": "Tammy Hines",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.993672539984045,
                5.347413386319971,
                2.728679573564785,
                9.074770731306296
            ]
        },
        {
            "name": "Jennifer Hobbs",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.321166579834106,
                4.505341099969952,
                7.6734406048422965,
                2.015909368821754
            ]
        },
        {
            "name": "Victor Flores",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.44893057823691,
                3.5511094547076554,
                2.794739480510841,
                9.759467525744132
            ]
        },
        {
            "name": "Amy Hurst",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.570744497326436,
                9.006973060511248,
                5.2894766010189995,
                6.942328283762469
            ]
        },
        {
            "name": "Dawn Walker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.8837760354664645,
                7.284049361437487,
                7.2280236595284695,
                7.12090837652744
            ]
        },
        {
            "name": "Mary Rivera",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.00425521936577,
                5.966562275081419,
                0.8913003941420312,
                0.684261882932128
            ]
        },
        {
            "name": "John Smith",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.7561095947439134,
                0.8993625081753709,
                4.075204869033207,
                6.473734454326393
            ]
        },
        {
            "name": "Matthew Barton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.299351173335372,
                1.3254212952047781,
                9.66919835109949,
                6.81195043466918
            ]
        },
        {
            "name": "Leslie Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.618548698883316,
                2.980883167148103,
                3.913300854953674,
                1.9418454464915935
            ]
        },
        {
            "name": "Tyler Medina",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.477314972396614,
                3.6163026032509755,
                9.947437115551894,
                6.433721145172591
            ]
        },
        {
            "name": "Rodney Stevens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.470379026282553,
                6.661498412388015,
                9.955815406708703,
                5.488055244657022
            ]
        },
        {
            "name": "Tara Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                5.0,
                7.0,
                3.0
            ]
        },
        {
            "name": "Denise Merritt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.8502088153808,
                6.845052751272435,
                5.074265329206521,
                3.679254320837665
            ]
        },
        {
            "name": "John Garcia",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Kelly Farmer",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.7376065555881526,
                2.1420253219975063,
                1.087855477098289,
                5.509139195674195
            ]
        },
        {
            "name": "Kelly Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.203862651507213,
                8.869468723505866,
                9.996800155920226,
                7.47848843726228
            ]
        },
        {
            "name": "Jennifer Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.784569010637871,
                9.652116367939291,
                8.678047230843418,
                9.111775286558528
            ]
        },
        {
            "name": "Alexa Collier",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.397672638510917,
                6.802944780340573,
                7.281909643351354,
                7.2593941788769465
            ]
        },
        {
            "name": "Stacey Bond",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.784353334173646,
                4.3849331353916705,
                8.97568362627262,
                8.43076844913347
            ]
        },
        {
            "name": "Lisa Briggs",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.842776440010878,
                3.8701866090111707,
                2.551579497419911,
                6.96298479996328
            ]
        },
        {
            "name": "Jenny Riddle",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.37355755200776,
                7.142583768095131,
                3.95804082256345,
                5.583461132909838
            ]
        },
        {
            "name": "Bryan Matthews",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.328242126036434,
                8.96116878672386,
                2.5133937656625607,
                5.79393264931372
            ]
        },
        {
            "name": "Gary Abbott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.5200713395489343,
                6.805883080919949,
                5.320483473469736,
                3.707635969949206
            ]
        },
        {
            "name": "Shelly Horton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.837520704120314,
                0.9531480331443556,
                7.515402259632275,
                9.385754684258496
            ]
        },
        {
            "name": "Caitlin Bell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.833929371259494,
                6.5124945473708635,
                7.4229001445264275,
                2.1852379988734065
            ]
        },
        {
            "name": "Shannon Larsen",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                4.0,
                1.0
            ]
        },
        {
            "name": "Frank Clark",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                1.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Carol Nash",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.806262247445645,
                6.393919590893148,
                9.422014290772792,
                5.484303136205252
            ]
        },
        {
            "name": "Matthew White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Daniel Edwards",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.9703010772470323,
                7.8715241619182,
                2.413719789399724,
                3.0214809503645252
            ]
        },
        {
            "name": "Kelly Martinez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                2.0,
                2.0,
                1.0
            ]
        },
        {
            "name": "Tammy Harmon",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                3.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Mary Moreno",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.186056383224222,
                1.517540525444392,
                0.9151173968439396,
                6.603320502357154
            ]
        },
        {
            "name": "George Kirby",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.529291344017128,
                9.831028931711352,
                8.500600282347396,
                5.730289019672852
            ]
        },
        {
            "name": "Donna Roy",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                7.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Collin Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.732384551470732,
                9.048364840800232,
                5.366028212008005,
                6.270211441934876
            ]
        },
        {
            "name": "Mark Carlson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.4461589088167575,
                5.043015082174978,
                5.5633585452962295,
                4.012982808713002
            ]
        },
        {
            "name": "Lisa Johnson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.274521795109077,
                5.173053613520518,
                4.706160216305502,
                1.6304010958717716
            ]
        },
        {
            "name": "Nancy Lane",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.4738723898802507,
                3.741998432744702,
                8.27187456432005,
                9.681763333667316
            ]
        },
        {
            "name": "Sarah Walters",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.1945587054433717,
                4.3824841194573025,
                2.897639531134914,
                2.0316207238501414
            ]
        },
        {
            "name": "Adrian Hines",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.004349832907755,
                6.256096065991072,
                7.191276172250579,
                3.1067973385773855
            ]
        },
        {
            "name": "Ruben Howard",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.328975044533895,
                1.8117208566508594,
                4.780770445777446,
                4.441689301583561
            ]
        },
        {
            "name": "Anthony Allen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.31424833663524,
                7.4162811834027265,
                5.311487732958202,
                2.4947377137019817
            ]
        },
        {
            "name": "Jason Montes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.259145114192073,
                5.126417692063554,
                4.255626598627421,
                9.606770429111211
            ]
        },
        {
            "name": "Robert Price",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                2.0,
                6.0,
                2.0
            ]
        },
        {
            "name": "Bryan Mcclain",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                9.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Paul Schroeder",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.5991445062522445,
                6.605362263756146,
                9.324354569584177,
                5.325644333755871
            ]
        },
        {
            "name": "Anthony Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.028275766925093,
                2.918010566184358,
                8.70815749258568,
                8.735197812344673
            ]
        },
        {
            "name": "Laura Ward",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.666193779590753,
                5.856408086588829,
                7.877825028614228,
                5.184319152876926
            ]
        },
        {
            "name": "Deborah Black",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.626667222420297,
                5.790541338282073,
                9.441330351964535,
                9.774283010390466
            ]
        },
        {
            "name": "Trevor Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.21463743778663255,
                5.399877920008246,
                9.47995450868787,
                5.860590406753648
            ]
        },
        {
            "name": "Jake Mcdowell",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                7.0,
                8.0
            ]
        },
        {
            "name": "Donna Lawson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                0.0,
                7.0
            ]
        },
        {
            "name": "Jose Valencia",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.635985915406693,
                3.820751127967145,
                2.597913973604639,
                6.745865006084534
            ]
        },
        {
            "name": "Megan Shaffer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.543362301877597,
                4.9043073521575025,
                8.45586456095264,
                9.730855069398807
            ]
        },
        {
            "name": "Anita Brown",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.1211601972936425,
                1.2541950705477145,
                6.918705462394703,
                5.970437303261847
            ]
        },
        {
            "name": "Patricia Davis",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.45394864330894,
                0.13835198696065565,
                5.476283909053531,
                4.868582016093492
            ]
        },
        {
            "name": "Anthony Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.034324205407348,
                2.3457899307426446,
                9.646389024573484,
                3.266016675798133
            ]
        },
        {
            "name": "Timothy James",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.656805544488151,
                2.8768843306535268,
                1.7860473600127689,
                2.958111396644187
            ]
        },
        {
            "name": "Erik Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.4489217914316885,
                9.3005090419634,
                3.2926622803034498,
                9.567990667048182
            ]
        },
        {
            "name": "Joseph Simpson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.645957705785849,
                7.08892308636922,
                7.664721964049775,
                5.13201254793289
            ]
        },
        {
            "name": "Dennis Lara",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Jessica Cline",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.908789507055193,
                8.309209088690887,
                8.51687965828749,
                8.939339419823751
            ]
        },
        {
            "name": "Sara Preston",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.434250166701866,
                8.597026569052034,
                3.9028877149706216,
                5.581283380420067
            ]
        },
        {
            "name": "Eric Simmons",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                4.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Mario Kennedy",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.02269521963966,
                6.451027756735993,
                6.8783698060212615,
                9.32131588058554
            ]
        },
        {
            "name": "Nathan Simpson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                0.0,
                4.0,
                4.0
            ]
        },
        {
            "name": "Andrea Guzman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.493619362118172,
                4.6780679308293145,
                9.480905426868333,
                7.974094402817139
            ]
        },
        {
            "name": "Joseph Ingram",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                5.0,
                8.0
            ]
        },
        {
            "name": "Brandon White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                9.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Lauren Rice",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.3991665603956935,
                9.209121935569245,
                6.653932828472973,
                1.4488998411539957
            ]
        },
        {
            "name": "Emily Padilla",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                2.0,
                2.0
            ]
        },
        {
            "name": "Andrew Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.3839456339496817,
                6.302269203828486,
                8.549072510045653,
                6.149650577108132
            ]
        },
        {
            "name": "Whitney Bailey",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.1598232147970673,
                5.997939666750392,
                4.527496626373026,
                5.88158155198831
            ]
        },
        {
            "name": "James Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                8.0,
                9.0
            ]
        },
        {
            "name": "Kyle Hicks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.774811448841866,
                3.6314282422369955,
                5.0002352874992715,
                9.903184362122063
            ]
        },
        {
            "name": "Tracy Browning",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.985623766082181,
                7.6284722069532584,
                7.909038999747122,
                1.6268071546711655
            ]
        },
        {
            "name": "Kayla Bullock",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                0.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Debbie Rios",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                4.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Melinda Ortega",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.828404635072339,
                6.996171275358418,
                3.2845909476792823,
                8.937042670354394
            ]
        },
        {
            "name": "Brian Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.3560218222116525,
                9.300296035618075,
                5.10668736577287,
                1.6238220716263236
            ]
        },
        {
            "name": "Darrell Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.105757710960582,
                6.464429065129139,
                8.740296132645632,
                3.658005703430675
            ]
        },
        {
            "name": "Logan Lewis",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                8.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Craig Rhodes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.19994141339681,
                2.760068821041859,
                0.7580806094402568,
                8.708927135000206
            ]
        },
        {
            "name": "Earl Lynch",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                9.0,
                1.0,
                4.0
            ]
        },
        {
            "name": "Dean Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.075023890603072,
                3.486574446964163,
                7.6349170960707715,
                5.090288664946564
            ]
        },
        {
            "name": "Kathryn Harris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.955645552404759,
                6.05024336405822,
                1.049749643753575,
                8.351574016073894
            ]
        },
        {
            "name": "Erika Fritz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.830684051202574,
                8.206558231096903,
                5.301881917807734,
                6.897622211979525
            ]
        },
        {
            "name": "Cynthia Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Kenneth Carter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.108213276429012,
                8.417258197589595,
                6.20635272946026,
                9.74641703654641
            ]
        },
        {
            "name": "Theresa Wright",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                3.0,
                5.0,
                9.0
            ]
        },
        {
            "name": "Joseph Ware",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.055707981477424,
                8.195060706551354,
                6.984212470297109,
                4.584346347518243
            ]
        },
        {
            "name": "David Williams",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.392593444137132,
                9.685039727238017,
                4.150147314798323,
                2.2231485568104232
            ]
        },
        {
            "name": "Devon Mathis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.316269740295997,
                2.7952654507189045,
                5.717288940595797,
                7.191114526896047
            ]
        },
        {
            "name": "Jacob Abbott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.310390701052263,
                9.894855069906106,
                4.206549944040393,
                4.163368355975107
            ]
        },
        {
            "name": "Monica Carney",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.574482474835941,
                9.253942388702985,
                4.362327390802045,
                9.77411893456869
            ]
        },
        {
            "name": "Brandon Chavez",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.374343569088321,
                7.9392755217948885,
                8.333153602788533,
                1.908819645107294
            ]
        },
        {
            "name": "Dustin Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.038305532961857,
                3.138774815989029,
                9.475393994823477,
                1.5855833310150111
            ]
        },
        {
            "name": "Willie Fisher",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.977922259246137,
                8.457727130512517,
                8.996476938160576,
                7.266387100442238
            ]
        },
        {
            "name": "Jaime Sosa",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.943510999470233,
                4.077830253335878,
                2.4436720928905964,
                7.5671356624072414
            ]
        },
        {
            "name": "Rachel Hickman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.4203478203245625,
                9.1827350079583,
                1.6268033855001394,
                9.182291621909176
            ]
        },
        {
            "name": "Tyler Miller",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                9.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Tyler Hanson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Christina Ware",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.460562199491383,
                7.517609081455028,
                7.237855187867503,
                5.6775212416351035
            ]
        },
        {
            "name": "Eric Braun",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.247261351643657,
                4.191043227032995,
                9.874417866022231,
                7.384177754133746
            ]
        },
        {
            "name": "Mia Copeland",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.074602244413066,
                4.532724132091334,
                8.264947648290077,
                4.040808079927278
            ]
        },
        {
            "name": "April Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.667853520302417,
                3.56447070800525,
                8.771485469562476,
                7.133154176873353
            ]
        },
        {
            "name": "John Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.7912426102148236,
                8.025571662350906,
                7.067249006379679,
                2.465339246258487
            ]
        },
        {
            "name": "Christina Hunt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.503710299865037,
                3.6490114876156623,
                9.897357379459699,
                4.615956667631252
            ]
        },
        {
            "name": "Kendra Summers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                8.0,
                6.0
            ]
        },
        {
            "name": "Patricia Roman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.630596700511139,
                7.052643236053092,
                4.403829112816635,
                7.5389772926614125
            ]
        },
        {
            "name": "Daniel Travis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.657103966161195,
                8.3515316987484,
                6.258675308171311,
                4.68097396707059
            ]
        },
        {
            "name": "Bruce Phillips",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.372358683225702,
                2.206028093733661,
                9.245592184115472,
                2.151471611479763
            ]
        },
        {
            "name": "Molly Mcbride",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.6804174798562486,
                8.234665401443099,
                8.559378862626136,
                6.616698333761612
            ]
        },
        {
            "name": "Jesse Long",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                6.0,
                6.0,
                0.0
            ]
        },
        {
            "name": "Brenda Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.921039604737486,
                7.51300519021391,
                4.618294044638233,
                9.139853514719137
            ]
        },
        {
            "name": "David Spencer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.129932350441357,
                4.074314093360267,
                1.3691141842751793,
                9.531319239088722
            ]
        },
        {
            "name": "Eric Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.299853200192807,
                1.1841577076564254,
                1.625438912756618,
                6.904824678910525
            ]
        },
        {
            "name": "Shannon Watson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.891014731199225,
                5.052281765403245,
                6.150909208899675,
                3.0061463003727966
            ]
        },
        {
            "name": "Matthew Hodge",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.433697231590674,
                1.0979405179259922,
                5.028261428684004,
                6.4771525628537265
            ]
        },
        {
            "name": "Cindy Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                7.0,
                5.0
            ]
        },
        {
            "name": "Thomas Lyons",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.826438135908178,
                8.672222032984251,
                9.673304582688747,
                3.780372904543085
            ]
        },
        {
            "name": "Thomas Vega",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                2.0,
                8.0
            ]
        },
        {
            "name": "Ryan Solis",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                3.0,
                6.0,
                2.0
            ]
        },
        {
            "name": "Kelly Price",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                6.0,
                5.0,
                0.0
            ]
        },
        {
            "name": "David Williams",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                8.0,
                0.0
            ]
        },
        {
            "name": "Darius Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.525980169225191,
                1.5325242505199208,
                7.865072998757903,
                6.610922369366497
            ]
        },
        {
            "name": "Logan Tucker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.972411802635138,
                3.6860536610997614,
                0.8826881869931247,
                6.864293991095467
            ]
        },
        {
            "name": "Eric Benton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.902149939325341,
                4.263095535975482,
                9.06433410264031,
                9.224525099163827
            ]
        },
        {
            "name": "William Price",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.120283275083217,
                6.760287390978156,
                5.9280417293562735,
                6.469146874927958
            ]
        },
        {
            "name": "Michael Yu",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.495844657823053,
                3.4436084735639,
                4.859899109903288,
                2.2831554733688035
            ]
        },
        {
            "name": "Sandra Becker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.403390712038921,
                9.346790027186533,
                1.1190951417471469,
                6.280395694881687
            ]
        },
        {
            "name": "Katrina Scott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.848380912969866,
                8.522936662456221,
                4.082985418279479,
                5.670262165405492
            ]
        },
        {
            "name": "Ashley Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.880446951970687,
                3.779719395432875,
                8.677985790257717,
                8.180322984341696
            ]
        },
        {
            "name": "Stacey Page",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.558417358647399,
                7.316318817252956,
                2.541057951834491,
                8.928489942332854
            ]
        },
        {
            "name": "Amanda Sutton",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.509809514675941,
                9.878959213586555,
                1.9249663198339209,
                2.7134269788421443
            ]
        },
        {
            "name": "Jonathon Flynn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.659005334437133,
                1.8650612795442048,
                0.3576628218789206,
                9.079110395539926
            ]
        },
        {
            "name": "Timothy Macias",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                6.0,
                0.0,
                9.0
            ]
        },
        {
            "name": "Lori Welch",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.098978405452906,
                3.9215214934480875,
                5.164216830350549,
                0.7662015670558535
            ]
        },
        {
            "name": "Kathleen Henry",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                8.0,
                7.0
            ]
        },
        {
            "name": "Donna Alvarez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.953457874184467,
                8.800196836598388,
                8.343872842082913,
                6.196005422335226
            ]
        },
        {
            "name": "Michael Nelson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.442450883038271,
                1.4491922414570657,
                9.125528390681545,
                8.272377347020925
            ]
        },
        {
            "name": "Matthew Black",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.67132606524931,
                2.132893269022518,
                4.033713735692633,
                7.192386505578053
            ]
        },
        {
            "name": "Elizabeth Mack",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                5.0,
                6.0
            ]
        },
        {
            "name": "James Johnson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.804683027292853,
                9.577616508384995,
                8.106664617195875,
                4.40929264790565
            ]
        },
        {
            "name": "Sarah Hall",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.47481931352345,
                8.097921539511448,
                2.8314422316093877,
                1.6763935956648413
            ]
        },
        {
            "name": "Lauren Duncan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.416427121825615,
                5.386345806863231,
                7.223416404793344,
                8.572068118342388
            ]
        },
        {
            "name": "Morgan Braun",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                5.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "John Phillips",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.1186623937007105,
                4.286472641036531,
                4.922379305190457,
                5.023670609444649
            ]
        },
        {
            "name": "Sabrina Steele",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.251279474062686,
                8.616034851749669,
                4.477303401057484,
                7.098228756861282
            ]
        },
        {
            "name": "James Hanson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                4.0,
                8.0,
                9.0
            ]
        },
        {
            "name": "Bryan Ferguson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.880694210712319,
                8.92651541553801,
                3.288657960909835,
                7.287920020900628
            ]
        },
        {
            "name": "Chad Reed",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.035799706629317,
                5.556410194032968,
                5.056906198693731,
                4.990516715309746
            ]
        },
        {
            "name": "Rhonda Mendoza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.242107271274552,
                7.551733938532146,
                6.136559832799052,
                5.440081855607605
            ]
        },
        {
            "name": "Kimberly Logan",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.98439935606708,
                4.30858580498656,
                4.071767759154657,
                4.589834896948045
            ]
        },
        {
            "name": "Lisa Barnes",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                9.0,
                4.0,
                6.0
            ]
        },
        {
            "name": "Courtney Sharp",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.558695382849011,
                8.516446516436481,
                6.950160047577994,
                9.89716112602155
            ]
        },
        {
            "name": "Angel Rubio",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Kenneth Perry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.414607495392685,
                5.657060018799125,
                8.970166635703002,
                8.949507863962086
            ]
        },
        {
            "name": "Jackson Gomez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.4620356821847835,
                4.600446340083321,
                3.3256034133084404,
                1.3892863802526496
            ]
        },
        {
            "name": "Dale Schultz",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.4097569801356569,
                7.105722676065216,
                5.195330925666567,
                2.5897480544613827
            ]
        },
        {
            "name": "Joseph Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.342561306304832,
                4.984252435925423,
                4.66024210796466,
                6.340152346524208
            ]
        },
        {
            "name": "Shannon Myers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                7.0,
                1.0,
                6.0
            ]
        },
        {
            "name": "Hannah Sanchez",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8387823213844154,
                7.955526273196911,
                5.672356856039728,
                7.123677077052886
            ]
        },
        {
            "name": "Scott Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.931416563431831,
                7.065394036054746,
                2.9761252162686977,
                4.071808821230632
            ]
        },
        {
            "name": "Jeffery Fisher",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.357784077777268,
                9.937891669866186,
                9.509879694502848,
                3.425131382324574
            ]
        },
        {
            "name": "Deanna Gilbert",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.637770915965926,
                5.990497114955645,
                9.325890055828493,
                1.2906711239690336
            ]
        },
        {
            "name": "Jason Sanders",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.86775319574029,
                7.371333407079403,
                2.5703611767303327,
                9.770747482873254
            ]
        },
        {
            "name": "Anne Reeves",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.414445663623722,
                9.804991914946605,
                6.70209423937822,
                8.611693068904723
            ]
        },
        {
            "name": "Jeremy Fritz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.138145915770128,
                3.071035152156858,
                7.659111129170658,
                6.417579415967195
            ]
        },
        {
            "name": "Jimmy Ingram",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.9901050239883595,
                6.9774624509052465,
                8.554417618580208,
                6.032655532743584
            ]
        },
        {
            "name": "Matthew Webb",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                1.0,
                6.0
            ]
        },
        {
            "name": "Lynn Holt",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.052880041665848,
                9.701946829937821,
                0.7053639979210342,
                3.250832068562604
            ]
        },
        {
            "name": "Charles Bolton",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.932561222152502,
                3.461917678518157,
                7.838960883593728,
                8.847463600963806
            ]
        },
        {
            "name": "Deanna Wilson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Thomas Medina",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.67687600221002,
                9.291301481942817,
                1.8153728933423028,
                9.331449077877739
            ]
        },
        {
            "name": "Joyce Castro",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                3.0,
                4.0,
                6.0
            ]
        },
        {
            "name": "Jon Leonard",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                2.0,
                2.0,
                8.0
            ]
        },
        {
            "name": "Kaitlyn Hicks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.956491476855364,
                4.773810344253638,
                4.0760785038506695,
                7.940174604137513
            ]
        },
        {
            "name": "Wesley Vaughn",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                5.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Michael Rivera",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                9.0,
                2.0,
                2.0
            ]
        },
        {
            "name": "Brenda Sims",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                4.0,
                3.0
            ]
        },
        {
            "name": "Donald Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.3246955716173145,
                2.616311347059261,
                3.8377942640759044,
                8.928911075749712
            ]
        },
        {
            "name": "Jamie Miller",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                5.0,
                4.0
            ]
        },
        {
            "name": "Jennifer Moss",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.733201316012874,
                5.19223348664732,
                3.8640275108451716,
                6.324197331621843
            ]
        },
        {
            "name": "Martin Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                5.0,
                6.0
            ]
        },
        {
            "name": "Norman Wall",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "April Dawson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.142798740630182,
                5.751332649986295,
                9.976222805540424,
                5.278695355622082
            ]
        },
        {
            "name": "Gloria Gentry",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                9.0,
                5.0
            ]
        },
        {
            "name": "Betty Kennedy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.914586752013077,
                6.490724222837121,
                5.476995839723759,
                6.907560845711666
            ]
        },
        {
            "name": "David Floyd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.733574114699596,
                9.717301249777167,
                6.413628784057521,
                8.801960251735053
            ]
        },
        {
            "name": "Carla Anderson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Jessica Acosta",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                8.0,
                0.0
            ]
        },
        {
            "name": "Patricia Shaw",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.1846583291845838,
                0.3776123378962073,
                1.7391967530101708,
                7.805228756038042
            ]
        },
        {
            "name": "Felicia Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.630064337892404,
                8.248968406941021,
                6.776286610839527,
                5.14111628802775
            ]
        },
        {
            "name": "Sean Owens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.441727304318664,
                9.543887005147994,
                6.1109916892123834,
                6.674970686750577
            ]
        },
        {
            "name": "Andrew Duncan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.818969049400623,
                5.284986054518972,
                4.314446427848534,
                2.510892860279637
            ]
        },
        {
            "name": "Paul Stanley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.950951805204031,
                5.7049734607206295,
                9.257166381090142,
                9.322073361855235
            ]
        },
        {
            "name": "Todd Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "Philip Greer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.389090561974468,
                0.90190035387547,
                5.79172593502283,
                8.318570238980994
            ]
        },
        {
            "name": "Jason Scott",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                5.0,
                5.0,
                7.0
            ]
        },
        {
            "name": "Jeffrey Hoover",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                0.0,
                2.0,
                9.0
            ]
        },
        {
            "name": "Erica Andrews",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                2.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Bob Perez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8326778348774155,
                8.64361248664545,
                6.435554995477142,
                9.43278653367719
            ]
        },
        {
            "name": "Charles Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Michael Tyler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.704870431835113,
                3.321598459991292,
                9.38702206217085,
                3.2599862945048708
            ]
        },
        {
            "name": "Robert Snow",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.709712080585893,
                2.1958190799296204,
                7.526278127667883,
                8.840691815252507
            ]
        },
        {
            "name": "Kimberly Bird",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.6171996214557125,
                9.334609633787657,
                1.4696396407761168,
                9.012037929817975
            ]
        },
        {
            "name": "Sarah Munoz",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.5132992590967302,
                7.066388739327993,
                3.3707350570880457,
                4.1767152823731495
            ]
        },
        {
            "name": "Michael Carter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.573636400346532,
                1.9039934629440627,
                2.6528593068963007,
                4.098384380874051
            ]
        },
        {
            "name": "Frank Leon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.556238664424425,
                8.522875245416778,
                6.278719478563081,
                7.153198953813307
            ]
        },
        {
            "name": "Carrie Fields",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.916798681478275,
                7.377607039851615,
                7.515855515655881,
                8.527318158773998
            ]
        },
        {
            "name": "Kathy Erickson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.942589310093945,
                0.06411601267414493,
                3.808719845172146,
                1.849558383724121
            ]
        },
        {
            "name": "Melissa Waters",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.041254066796174,
                4.990997214176617,
                7.844626884996934,
                4.552644932098489
            ]
        },
        {
            "name": "Lindsay Cortez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.963711161398035,
                0.8149437988148845,
                5.671024688321939,
                9.670321298805197
            ]
        },
        {
            "name": "Courtney Wells",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.8824405630686867,
                3.7229973540661945,
                4.377914581230819,
                3.168113043395854
            ]
        },
        {
            "name": "Johnny Hancock",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.799357473367433,
                6.262797412179336,
                8.074002578392118,
                8.805146845567737
            ]
        },
        {
            "name": "James Jackson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                7.0,
                7.0
            ]
        },
        {
            "name": "Karen Morrison",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                2.0,
                2.0
            ]
        },
        {
            "name": "Kenneth Mason",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.957378928093044,
                3.3777073400967033,
                8.065943803373116,
                5.01552698059499
            ]
        },
        {
            "name": "John Flores",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.46379866799466,
                8.783023015896005,
                0.551588992560348,
                5.722841992868889
            ]
        },
        {
            "name": "Joel Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.7534432933947475,
                9.710441030031564,
                5.191195268055155,
                2.3520093823153245
            ]
        },
        {
            "name": "Stephanie Rush",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Misty Ball",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.333757913124268,
                0.47803346068827646,
                8.0358752884497,
                4.8587812102446675
            ]
        },
        {
            "name": "Frank Abbott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.344234325498501,
                1.8608949135353998,
                7.155728685980143,
                7.365616640580007
            ]
        },
        {
            "name": "Bruce Clark",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                6.0,
                3.0
            ]
        },
        {
            "name": "Lori Mann",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.930762095848605,
                0.3205167556701443,
                2.718554234424509,
                7.514841804490664
            ]
        },
        {
            "name": "Larry Gray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.749151477746004,
                6.266105470964951,
                6.186240058698498,
                5.173127085999311
            ]
        },
        {
            "name": "Jon Green",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                8.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Emily Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                2.0,
                1.0
            ]
        },
        {
            "name": "Nichole Drake",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.768397834620725,
                8.985994229198962,
                3.1601843572336943,
                9.896055771178569
            ]
        },
        {
            "name": "Paul Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.804201992694118,
                5.006259946826903,
                9.748838670202991,
                4.508299824707173
            ]
        },
        {
            "name": "Edwin Medina",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.536768868186625,
                4.191907027661459,
                9.13732040907267,
                6.37686421339203
            ]
        },
        {
            "name": "Teresa Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.075207549373507,
                2.950451141735159,
                5.075100289063569,
                6.118524032810031
            ]
        },
        {
            "name": "Jared Davidson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.120111305388384,
                2.4904276944196466,
                5.274907477195443,
                6.676080483793694
            ]
        },
        {
            "name": "Shaun Small",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.244454004986384,
                0.9436282579823041,
                5.337320998522489,
                6.009474740083204
            ]
        },
        {
            "name": "Kristi Barrera",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Amber Ware",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.2703428253024724,
                4.489082046706628,
                3.583362173343943,
                0.9167903404363369
            ]
        },
        {
            "name": "Richard Wood",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.51546611537392,
                6.737692179537059,
                7.547141440958499,
                9.110631592796498
            ]
        },
        {
            "name": "Bill Gilmore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.747333530882664,
                9.824782183881991,
                1.5751399176579561,
                8.240404827143319
            ]
        },
        {
            "name": "Cameron Scott",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9905337167528114,
                9.111933050748586,
                8.568547297122805,
                6.121162688129006
            ]
        },
        {
            "name": "Dana Wilkinson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.6836758230009643,
                8.544648885859448,
                1.1836850348618577,
                9.255956333951437
            ]
        },
        {
            "name": "Laura Martinez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Jasmin Kim",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.248683325222887,
                4.755536121345019,
                1.4736177499151375,
                8.197100234215828
            ]
        },
        {
            "name": "Thomas Barr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.4264409110195055,
                5.468112214392428,
                7.786777614064731,
                7.823997460275011
            ]
        },
        {
            "name": "Randy Leblanc",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.215936495601449,
                7.011576103351929,
                6.781676203179217,
                8.875172871334543
            ]
        },
        {
            "name": "Angela Ball",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                4.0,
                2.0
            ]
        },
        {
            "name": "Jennifer Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.913414244494282,
                2.7548640284998176,
                0.8871940579934732,
                8.415623252241922
            ]
        },
        {
            "name": "Tony Murphy",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.615294045760166,
                9.405529897805657,
                7.473292071830508,
                5.123049439242181
            ]
        },
        {
            "name": "Ryan Wagner",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                1.0,
                7.0
            ]
        },
        {
            "name": "Jose Lucas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.684651249635573,
                5.824402144450474,
                5.666805720648151,
                8.685179477740194
            ]
        },
        {
            "name": "Michael Martin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.8503243752751106,
                6.856256761785384,
                5.336529770339771,
                8.519782121116682
            ]
        },
        {
            "name": "Alison Warner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.4602825181386363,
                6.656885729611312,
                6.995532890990573,
                3.8008167533279495
            ]
        },
        {
            "name": "Mariah Hart",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.109532245951362,
                9.906820068549138,
                5.233693298812309,
                2.249163924287081
            ]
        },
        {
            "name": "Melissa Snyder",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                3.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "David Baker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.013762236117466,
                5.3417737522610125,
                9.54379168450907,
                9.291763132235914
            ]
        },
        {
            "name": "Jessica Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.968859879012766,
                8.541332960022082,
                5.9916259000190175,
                2.2588658736553113
            ]
        },
        {
            "name": "David Howard",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                2.0,
                7.0,
                0.0
            ]
        },
        {
            "name": "Paul Cooper",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.314128790232752,
                6.405810103238373,
                6.815230886780111,
                7.632937460515878
            ]
        },
        {
            "name": "Timothy Reilly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.49682869644821,
                9.417766839274863,
                5.323741990364573,
                3.157836747430794
            ]
        },
        {
            "name": "Zachary Finley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.8219651207613694,
                8.096990729308294,
                4.33929662650039,
                9.848543921229853
            ]
        },
        {
            "name": "Terri Tran",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.756897221491353,
                3.106614064616267,
                0.307891603085284,
                5.234419731910509
            ]
        },
        {
            "name": "Mark Rodriguez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.382947057544493,
                4.1556720189709795,
                5.241801671394518,
                7.640675062649671
            ]
        },
        {
            "name": "James Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.513255596282585,
                9.953216244472967,
                7.310458513387688,
                4.684642063809435
            ]
        },
        {
            "name": "Nancy Lee",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Mark Mason",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.349635193856838,
                0.30494068417381454,
                4.871308289818089,
                9.482050032646146
            ]
        },
        {
            "name": "Taylor Campos",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.6115069342885837,
                4.25346933823818,
                4.4576930983448975,
                9.88287609064889
            ]
        },
        {
            "name": "Dana Brady",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Tyler Watts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8089268861281518,
                7.78751604611811,
                5.384049970549753,
                7.874745011721492
            ]
        },
        {
            "name": "Christina Ryan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.719261909786974,
                4.239213212222584,
                4.3442509372765015,
                7.086667756417117
            ]
        },
        {
            "name": "Ryan Cooper",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.144342962274226,
                0.6720035673529487,
                6.347238118736732,
                3.0756568596705454
            ]
        },
        {
            "name": "Denise Hopkins",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Carmen Woods",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.743724969041935,
                4.006937459465698,
                8.116183546592984,
                6.218824998595506
            ]
        },
        {
            "name": "Sharon Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.531202869894262,
                9.267305957497369,
                6.875719907686449,
                5.7457838486316115
            ]
        },
        {
            "name": "Laura Stanley",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                0.0,
                3.0
            ]
        },
        {
            "name": "Jennifer Cole",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                2.0,
                1.0
            ]
        },
        {
            "name": "Peggy Evans",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.628226087343677,
                0.3939204893770183,
                6.7244260519929,
                7.133702510064978
            ]
        },
        {
            "name": "Nancy Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.664618091568276,
                7.859637990012429,
                7.895337045758773,
                6.421424510479791
            ]
        },
        {
            "name": "Judy Blackburn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.913231142347734,
                3.7711951995324924,
                2.289558488210041,
                9.779490650281684
            ]
        },
        {
            "name": "Meghan Taylor",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.345943979687996,
                6.188209634664976,
                0.6730439758318645,
                4.009617284105009
            ]
        },
        {
            "name": "Bill Haney",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.537647476221608,
                2.863761376290887,
                4.115204169358066,
                6.802647080073649
            ]
        },
        {
            "name": "Michael Cannon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.446149466759712,
                5.29864618306783,
                2.8279215306950904,
                4.275645268395813
            ]
        },
        {
            "name": "Hannah Watson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.558182547586929,
                8.393743394570674,
                6.3492060540595805,
                7.46937410369903
            ]
        },
        {
            "name": "Bryan Cook",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.476747286520985,
                8.615617727096362,
                2.211374982312462,
                6.282707102046512
            ]
        },
        {
            "name": "Laura Ross",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.0400736338808825,
                5.12277674113797,
                7.758076104677026,
                8.271730469681023
            ]
        },
        {
            "name": "Toni Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.514243966721053,
                7.231574290935789,
                1.5720138910901882,
                9.812856646931138
            ]
        },
        {
            "name": "Amanda Allen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.408418203495541,
                4.314329152839977,
                9.175170234368773,
                8.064824439042601
            ]
        },
        {
            "name": "Gabriel Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.125320032466497,
                9.4988727850572,
                5.258713675227677,
                5.461361316023883
            ]
        },
        {
            "name": "Kara Williams",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.2694545371998345,
                8.818832266618008,
                4.281140997475773,
                9.381674028667211
            ]
        },
        {
            "name": "Lindsay George",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.338744054172696,
                2.3409789737154805,
                6.06366958526481,
                6.994488663470882
            ]
        },
        {
            "name": "Scott Hart",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Katie Baldwin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.519872866180271,
                5.791676721575257,
                8.199878155858165,
                1.8445304419430664
            ]
        },
        {
            "name": "Melissa Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.579271670757633,
                4.003615583783997,
                0.9002852695327865,
                9.227554117507847
            ]
        },
        {
            "name": "Joshua Liu",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                7.0,
                8.0,
                4.0
            ]
        },
        {
            "name": "Carlos Benitez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.102986495858768,
                9.414814471822426,
                1.531138797651788,
                7.558787367360699
            ]
        },
        {
            "name": "Ryan Davenport",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.895159539159232,
                9.879988926087107,
                4.821961254245859,
                7.806286974437617
            ]
        },
        {
            "name": "William Hines",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.515623240630108,
                9.718017528706012,
                7.456996863336865,
                8.282714260372927
            ]
        },
        {
            "name": "Wendy Taylor",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.9079359269594045,
                5.968412796647337,
                3.5946766991111656,
                5.6574825837982665
            ]
        },
        {
            "name": "Steve Dudley",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.663816328701092,
                4.439193563283717,
                6.077784001409826,
                8.911687069623065
            ]
        },
        {
            "name": "Joseph Munoz",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                2.0,
                8.0
            ]
        },
        {
            "name": "William Evans",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.722407694895644,
                7.943816613039509,
                5.773257235751743,
                9.323603427246123
            ]
        },
        {
            "name": "Tracy Ruiz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.6468224349641236,
                8.381390667557634,
                8.373668324043592,
                9.564626585438091
            ]
        },
        {
            "name": "Melvin Barrett",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                3.0,
                8.0
            ]
        },
        {
            "name": "Eric Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.42210504146302,
                8.396785976940501,
                2.2294698821331025,
                8.931031287832333
            ]
        },
        {
            "name": "Lynn Gordon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.95342977190666,
                7.679684348278718,
                7.278138859403377,
                4.396178900062147
            ]
        },
        {
            "name": "Crystal Key",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                6.017728635309085,
                1.6799904051555214,
                4.000551427382183,
                4.097010848205232
            ]
        },
        {
            "name": "Wendy Novak",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2844199465418114,
                9.640750154914082,
                8.373058909438495,
                3.229817747613471
            ]
        },
        {
            "name": "Andrew Reyes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                6.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Allison Tucker",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                5.0,
                9.0,
                1.0
            ]
        },
        {
            "name": "Alexis Johnson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.9385224122622686,
                6.061904791851634,
                4.082036963579954,
                1.9860646443810346
            ]
        },
        {
            "name": "Keith Reynolds",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                8.0,
                8.0,
                2.0
            ]
        },
        {
            "name": "Adam Andrews",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.3315451244933012,
                2.743546844181064,
                3.972600107377749,
                8.520359220709935
            ]
        },
        {
            "name": "Michelle Cole",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.814622251347943,
                6.9856211158387875,
                8.833021453654617,
                8.195345766870078
            ]
        },
        {
            "name": "Aaron Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.872682038019088,
                6.574345386572026,
                5.0664404178986,
                2.570087185831996
            ]
        },
        {
            "name": "Andrea Coleman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.9555205315376,
                7.8316526080780156,
                7.385352046616397,
                4.424119095473312
            ]
        },
        {
            "name": "Katie Rhodes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                7.0,
                5.0
            ]
        },
        {
            "name": "Seth Dennis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.120813994834586,
                7.467991868192741,
                1.7029333880831716,
                6.390085710555644
            ]
        },
        {
            "name": "Kristen Ellis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.766983021834122,
                8.913471964981856,
                2.602099603890786,
                0.7879187932221758
            ]
        },
        {
            "name": "Dustin Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.136911434729711,
                5.2333282149918325,
                2.381576174547503,
                1.6905307114465402
            ]
        },
        {
            "name": "John Holt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.5730762371490123,
                5.151532858954557,
                5.398746431162814,
                6.5816342382694515
            ]
        },
        {
            "name": "Patrick Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2954981238382393,
                6.140427412202918,
                7.004306317296831,
                8.819219804371825
            ]
        },
        {
            "name": "Andrea Vargas",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.27714799381399,
                5.493179093980286,
                1.4879194754889349,
                8.06781060675044
            ]
        },
        {
            "name": "Stefanie Cole",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.355919280761876,
                4.270368446055671,
                8.290247640509337,
                9.860475347048844
            ]
        },
        {
            "name": "Tyler Allen",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                6.0,
                8.0
            ]
        },
        {
            "name": "Ryan Gomez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.924944847698035,
                7.777206796690316,
                7.975888823381608,
                5.4176895254081465
            ]
        },
        {
            "name": "Tammy Dixon",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "Melanie Terry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.466587118378395,
                7.473127811017786,
                7.719805311266955,
                7.439125625040188
            ]
        },
        {
            "name": "Lisa Allen",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                1.0,
                4.0
            ]
        },
        {
            "name": "William Love",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                7.0,
                5.0
            ]
        },
        {
            "name": "Leah Kline",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                8.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "Mark Davenport",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.619619101910946,
                5.610196444104227,
                3.1108064589961897,
                1.6044746660086495
            ]
        },
        {
            "name": "Haley Francis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.159347495103473,
                1.6242525662610796,
                3.222340944923921,
                9.732815617172857
            ]
        },
        {
            "name": "Joseph Watson",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Leslie Mosley",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                2.0,
                8.0
            ]
        },
        {
            "name": "Timothy Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.423319557128289,
                3.565045699021053,
                3.4252559351073826,
                8.64111645514415
            ]
        },
        {
            "name": "Aaron Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.490744880308561,
                3.944693118448621,
                6.3209647953506405,
                9.1195773136335
            ]
        },
        {
            "name": "Adam Savage",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.967614430012485,
                4.43042645437028,
                4.889563418326679,
                3.677699639566785
            ]
        },
        {
            "name": "April Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                7.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Ian Rodgers",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.921527728648931,
                6.319535850661685,
                7.70385565579377,
                7.062947815020962
            ]
        },
        {
            "name": "Angela Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.200896429799727,
                3.9631973013646937,
                5.553256617578901,
                8.441617758975731
            ]
        },
        {
            "name": "Dustin Nelson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9475424597746835,
                9.497644954075612,
                9.870231387196128,
                7.764843380530837
            ]
        },
        {
            "name": "Brenda Silva",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                4.0,
                0.0
            ]
        },
        {
            "name": "Maria Watkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2309801209404865,
                1.6618478298015251,
                8.03466425608815,
                8.724601779579631
            ]
        },
        {
            "name": "Adrian Horton",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.343116894581745,
                0.11496359565131081,
                5.606418883292886,
                1.4996250373227382
            ]
        },
        {
            "name": "Grace Webb",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.044916943239295,
                6.592919094429755,
                8.20634139582119,
                1.741829921344527
            ]
        },
        {
            "name": "Tabitha Nelson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Emily Austin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.4100794543505,
                8.025543230277227,
                4.075546333266921,
                8.475752264115156
            ]
        },
        {
            "name": "Brenda Tate",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.19777261404373,
                7.036096122685683,
                7.720070125505525,
                1.4421019452272985
            ]
        },
        {
            "name": "James Collins",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                9.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Joseph Marquez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                7.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Frank Moran",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.224920520458074,
                2.462498380478589,
                3.5826432046224292,
                4.96061805307686
            ]
        },
        {
            "name": "Donna Webster",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7551290849515446,
                5.387075741153737,
                6.243228164623663,
                5.319366738975644
            ]
        },
        {
            "name": "John Zimmerman",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                6.0,
                9.0
            ]
        },
        {
            "name": "Robert Obrien",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.272189383240448,
                9.251483013498301,
                8.319394875392442,
                3.555408948868525
            ]
        },
        {
            "name": "Brandi Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.873808157297853,
                8.916136291610492,
                4.576912878838899,
                7.181007679168432
            ]
        },
        {
            "name": "Diane Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                1.0,
                8.0
            ]
        },
        {
            "name": "Tony Ho",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.548595835136178,
                2.1865150943186498,
                6.101250512883652,
                8.474632626045112
            ]
        },
        {
            "name": "Sheila Molina",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.631855011736645,
                3.2848956206052766,
                8.141456364697268,
                7.005267652922655
            ]
        },
        {
            "name": "Megan Callahan",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                6.0,
                8.0,
                2.0
            ]
        },
        {
            "name": "Corey Gill",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.788615941084993,
                6.834209588010413,
                9.679019606733075,
                8.753490913830515
            ]
        },
        {
            "name": "Angela White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "Ashley Parks",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                9.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Michael Miller",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                1.0,
                4.0
            ]
        },
        {
            "name": "Karen Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.285063350286157,
                7.791439433751247,
                8.467082128966855,
                1.3976808272213703
            ]
        },
        {
            "name": "Robert Bailey",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Chris Anderson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Nicole Long",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.320822507410626,
                3.6558362151497747,
                8.869819617707211,
                7.0930294464060815
            ]
        },
        {
            "name": "Cheryl Cannon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.756157726473527,
                1.0699851547446617,
                9.237445536871261,
                1.7828849355488774
            ]
        },
        {
            "name": "Sean Jimenez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                3.0,
                7.0,
                3.0
            ]
        },
        {
            "name": "Melanie Reeves",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.444645809076957,
                5.996782241501046,
                7.233012374629089,
                7.204292231791668
            ]
        },
        {
            "name": "Stacey Drake",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.073023352790823,
                2.8738733432998833,
                6.5584280800826535,
                8.422159682350033
            ]
        },
        {
            "name": "John Rios",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.129892672918686,
                1.732070282926323,
                7.541820382790507,
                5.977062264626408
            ]
        },
        {
            "name": "Lisa Davis",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.696141739461286,
                5.226073257398469,
                6.629915857122333,
                3.9939040319344503
            ]
        },
        {
            "name": "Jeffrey Gibson",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.668300065280933,
                1.7187704771198602,
                4.954637393187353,
                8.388851534442901
            ]
        },
        {
            "name": "Jennifer Wade",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.824628185495107,
                9.530727936225048,
                5.5956617583206505,
                7.472483035609772
            ]
        },
        {
            "name": "Meagan Estes",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.54856691568154,
                9.440247351342334,
                2.1429037664511537,
                5.251964580911502
            ]
        },
        {
            "name": "Dakota Brennan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.802853476076782,
                2.792123582495795,
                3.586498257203875,
                8.5357314931186
            ]
        },
        {
            "name": "Jerry Bates",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.7589631583146295,
                9.3180284409816,
                8.623130541573214,
                6.1146162974323115
            ]
        },
        {
            "name": "Scott Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.068392123418796,
                3.460408649135025,
                7.107342941762016,
                9.264210180090648
            ]
        },
        {
            "name": "Lisa Padilla",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.8976608988049,
                8.35932467916154,
                7.815604383433183,
                6.402832215472758
            ]
        },
        {
            "name": "Chase Marks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.327072108760727,
                4.29572754243384,
                7.698933561935597,
                5.171058652640448
            ]
        },
        {
            "name": "Tina Yoder",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.279479785606771,
                2.9083074292267903,
                9.83934036408389,
                0.11211744722929602
            ]
        },
        {
            "name": "David Thompson",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Jessica Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.529074313416354,
                1.108122207744482,
                6.902903312960925,
                6.97114236631846
            ]
        },
        {
            "name": "Paul Roberts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.971889713235126,
                3.3592252808923613,
                9.964332462627821,
                4.88452948334689
            ]
        },
        {
            "name": "Valerie Moses",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                5.0,
                8.0
            ]
        },
        {
            "name": "Kelsey Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.691116770576448,
                4.8892371092271505,
                3.7386245876411808,
                4.410709606444106
            ]
        },
        {
            "name": "Mark Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.5655424734265555,
                3.108724012146479,
                8.684032102974317,
                4.400741148074468
            ]
        },
        {
            "name": "Alex Fowler",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                2.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Gregory Perez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.717296716300982,
                8.732931150203614,
                4.636911874737558,
                3.6137115538020623
            ]
        },
        {
            "name": "Nicholas Rojas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.895136259194984,
                5.792457832030932,
                6.880869730930862,
                3.0595124436741292
            ]
        },
        {
            "name": "Anthony Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.758872962709038,
                2.2722643066481214,
                5.369352362814075,
                7.681810784561662
            ]
        },
        {
            "name": "Amy Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.956890992330658,
                9.96544408579494,
                6.733886383776355,
                8.884844842126213
            ]
        },
        {
            "name": "Rick Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.4211445745953455,
                7.420333303992748,
                4.380046854128507,
                5.924438398219934
            ]
        },
        {
            "name": "Jeff Gonzalez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.72614310775069,
                4.826588310752184,
                5.882486616180661,
                9.17569996920554
            ]
        },
        {
            "name": "Angela Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.864411788056857,
                6.3060773039865925,
                2.9379398938652472,
                4.78304408449759
            ]
        },
        {
            "name": "Theresa Paul",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.080953532616305,
                4.232675891970251,
                1.3586313865898445,
                4.112025913082267
            ]
        },
        {
            "name": "Monica Dennis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.622599086879166,
                4.097579092438485,
                3.547870233273212,
                7.4333757763874875
            ]
        },
        {
            "name": "Joseph Henson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.531489329322008,
                7.800811740043181,
                2.7717844174603408,
                2.6583932212435486
            ]
        },
        {
            "name": "Thomas Adkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.308752985108269,
                8.257626551845243,
                5.778345975664919,
                4.185659532516402
            ]
        },
        {
            "name": "Charles Ruiz",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.443900829385947,
                3.7933479969214323,
                2.6413672087434,
                3.5410535665756497
            ]
        },
        {
            "name": "Jeanne Mckee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.212915577978593,
                3.537158852954838,
                5.542452005047997,
                3.8855912184700356
            ]
        },
        {
            "name": "Ms. Dawn Grant",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                8.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "Jesus Turner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.641676650846662,
                7.683202016183816,
                3.8431963212380023,
                4.096714103835386
            ]
        },
        {
            "name": "Mario Meza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.294134927100451,
                7.30353831118753,
                6.957982680500864,
                6.647162257136187
            ]
        },
        {
            "name": "Steven James",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.928329374296448,
                8.153967027956083,
                8.197861738376576,
                1.4622377977270393
            ]
        },
        {
            "name": "Debbie Palmer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.765092928665123,
                6.244921694255151,
                3.8555874305464375,
                3.6394377514774643
            ]
        },
        {
            "name": "Ashley Martin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.300254753917805,
                9.973272689568347,
                7.993567431941972,
                5.791844423381185
            ]
        },
        {
            "name": "Derek Rosales",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "Paul Martin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.681006863915746,
                1.6637255525248982,
                3.5806041420565333,
                4.844299665681449
            ]
        },
        {
            "name": "Erin Decker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.571341231747855,
                6.477700417711345,
                5.540223212736262,
                9.35634380301302
            ]
        },
        {
            "name": "Alyssa Valdez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                6.0,
                2.0
            ]
        },
        {
            "name": "Thomas Henry",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Heidi Moody",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                8.148410553793656,
                0.9031369105667008,
                2.153445347994203,
                5.443166111953541
            ]
        },
        {
            "name": "Robert Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.141012226946064,
                8.863981782518842,
                5.134325160512984,
                4.361905592055437
            ]
        },
        {
            "name": "Jesse Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.538641908362887,
                5.685202107533291,
                7.311814094531451,
                0.9930103582799005
            ]
        },
        {
            "name": "Kenneth Beck",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.281631505938909,
                2.9023075540186207,
                6.212987379251235,
                9.509420903254169
            ]
        },
        {
            "name": "Shawn Pearson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.553537967303301,
                8.191902322026298,
                1.765319907957955,
                8.203655648436301
            ]
        },
        {
            "name": "Julia Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.4933073268450848,
                9.308618785758151,
                6.297784625764676,
                7.074673221097937
            ]
        },
        {
            "name": "Jennifer Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.949992542026513,
                8.488752737752222,
                1.3663410895823456,
                8.891485835215628
            ]
        },
        {
            "name": "Ashley Olson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.379139146265512,
                8.307326176303114,
                3.4859441437912464,
                2.4998830489161703
            ]
        },
        {
            "name": "Erin Duffy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.4913476473925775,
                9.762564848240157,
                5.064148131348852,
                8.490405727263223
            ]
        },
        {
            "name": "Jose Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.1282451706015877,
                8.187378544524805,
                9.12559503734827,
                3.5042910294469305
            ]
        },
        {
            "name": "Lydia Williams",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.538722369230973,
                4.648166325614701,
                1.8689405447751728,
                6.021947316955182
            ]
        },
        {
            "name": "Deanna Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.72749384355972,
                4.418156538899943,
                6.286145899033234,
                9.28220253590882
            ]
        },
        {
            "name": "Jacob Fisher",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.0579009198251708,
                4.648965615042991,
                2.3596399435210484,
                2.1989381670505943
            ]
        },
        {
            "name": "Jillian Nguyen",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.003230428135275,
                4.21052231059903,
                9.139226379955257,
                7.4608832745027165
            ]
        },
        {
            "name": "Rachel Vargas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.111019352776486,
                8.44311849100203,
                6.919839025269038,
                9.26031385462452
            ]
        },
        {
            "name": "Bryan Cook",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "James Baker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.687565815334104,
                7.136653780828185,
                7.7671944287444745,
                6.875658404641718
            ]
        },
        {
            "name": "Andrew Nichols",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.346237167204992,
                6.9601268844363275,
                5.657847839593931,
                6.377872455981963
            ]
        },
        {
            "name": "Richard Cooper",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.082535126046097,
                9.355842502959334,
                3.303995760858654,
                0.21174471902637293
            ]
        },
        {
            "name": "Angel Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.562563243676129,
                5.322565892818506,
                0.8362635672278942,
                6.463442956277499
            ]
        },
        {
            "name": "John Nichols",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.3473014390571505,
                5.52402767128226,
                9.650054182707326,
                5.848226408279266
            ]
        },
        {
            "name": "Lori Alvarado",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.514252858297283,
                4.53681886250717,
                2.239966835998216,
                1.2896357402291838
            ]
        },
        {
            "name": "Thomas Rice",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.61269486141349,
                1.1636824843862925,
                9.065290587548716,
                9.272667127226878
            ]
        },
        {
            "name": "Frances Taylor",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.670816094444197,
                0.7634320392897721,
                4.158155664585896,
                1.703979704002219
            ]
        },
        {
            "name": "Jamie Colon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.849094249120078,
                5.417637795526372,
                5.386783397566541,
                7.511553025817296
            ]
        },
        {
            "name": "Catherine Reed",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.672652672682294,
                3.9793954555795534,
                1.8068268737570723,
                6.24953093813699
            ]
        },
        {
            "name": "Natalie Baker",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.139836915718953,
                7.226309285718785,
                0.7867889036285001,
                2.7332990946472293
            ]
        },
        {
            "name": "Blake Cooper",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.654777564376732,
                4.2588892624913175,
                8.153962665171468,
                4.431863358850382
            ]
        },
        {
            "name": "Andrew Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.408966361156905,
                5.197923907187945,
                5.750526736568703,
                7.819386397509906
            ]
        },
        {
            "name": "Angela Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.376463026461728,
                5.179551456376817,
                8.704289422277544,
                2.556923446611192
            ]
        },
        {
            "name": "David Gonzalez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                8.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Tara Proctor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.754669164145339,
                3.3912066137214336,
                2.967599001973335,
                9.151026402601769
            ]
        },
        {
            "name": "Michael Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.061502828127443,
                5.6877175054201645,
                3.950502086430551,
                2.187776638808578
            ]
        },
        {
            "name": "Susan Wall",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                5.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Seth Peterson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                1.0,
                5.0,
                1.0
            ]
        },
        {
            "name": "Jamie Vega",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.161244266838667,
                8.974297682739493,
                4.948585017351097,
                4.1297789422324005
            ]
        },
        {
            "name": "Donald Kramer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.498090279607725,
                5.749785288266799,
                9.365705187314617,
                6.226301088436708
            ]
        },
        {
            "name": "Dana Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.455259548021087,
                7.06174176234355,
                6.726073504686259,
                7.203468166210847
            ]
        },
        {
            "name": "Audrey Kemp",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.7777937211049699,
                7.54199484862291,
                2.7193363453165063,
                5.69220808529646
            ]
        },
        {
            "name": "Michael Gross",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.59946354596217,
                6.091776938184221,
                5.505172690433966,
                1.5198826682963962
            ]
        },
        {
            "name": "Richard Owens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.151103442137712,
                6.403193626990699,
                8.347166295557443,
                2.5785349114938656
            ]
        },
        {
            "name": "Tina Chen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.756539716904171,
                3.3541317431138626,
                4.693417481688343,
                7.772749462569646
            ]
        },
        {
            "name": "Krista Dean",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.58864641934106,
                5.5671157680899475,
                1.2242845428066786,
                4.430882592291103
            ]
        },
        {
            "name": "Felicia Hayes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                4.0,
                1.0
            ]
        },
        {
            "name": "Kristin Murphy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.171961074715595,
                0.8813060716366756,
                9.373369718824124,
                9.714699380687602
            ]
        },
        {
            "name": "Stephanie Wong",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.258603887630673,
                5.684872694245601,
                4.518054640624813,
                8.081680585644621
            ]
        },
        {
            "name": "Betty Shelton",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                5.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Kyle Nelson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.652717393318369,
                8.614674621128849,
                3.674468401997608,
                1.383066980627504
            ]
        },
        {
            "name": "Daisy Allison",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                3.0,
                5.0,
                4.0
            ]
        },
        {
            "name": "Courtney Miles",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.307967737711944,
                9.240290682812658,
                0.8217013734076978,
                1.302838870717526
            ]
        },
        {
            "name": "Joseph Yang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.858126854794687,
                7.763881969578051,
                6.38297402467332,
                9.004720686689048
            ]
        },
        {
            "name": "Derek Morales",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.471750195819927,
                7.622373431212795,
                3.8605375980297914,
                3.129308432669528
            ]
        },
        {
            "name": "Nichole Park",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                2.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Kayla Andrews",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.853328081617835,
                8.733002640610442,
                5.667375258548474,
                4.830379159708083
            ]
        },
        {
            "name": "Jordan Ward",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "David Pope",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.803630151099177,
                3.247178312851349,
                6.075612943246552,
                9.082591817285763
            ]
        },
        {
            "name": "Tracey Russell",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.012289877184648235,
                9.29811360638691,
                2.8332642984673706,
                0.2586710151571312
            ]
        },
        {
            "name": "April Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.003371237903514,
                7.60751433851702,
                4.301276557136188,
                1.1564342726185612
            ]
        },
        {
            "name": "Ryan Wright",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.937576114910304,
                2.326510873710249,
                3.8771623757599567,
                7.660981770180736
            ]
        },
        {
            "name": "Mary Pham",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.290052632425287,
                9.164082797457718,
                4.045424711285394,
                3.4124320087831572
            ]
        },
        {
            "name": "Megan Lopez",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                1.0,
                3.0,
                9.0
            ]
        },
        {
            "name": "Joshua Payne",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.569082146044062,
                8.524896872740975,
                5.504287120102526,
                6.237733197205454
            ]
        },
        {
            "name": "Kelly Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.747486518760027,
                8.68992403209123,
                8.218816769511125,
                7.806489870349102
            ]
        },
        {
            "name": "Matthew Kerr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.736193898151899,
                5.853722661987952,
                7.287661493525785,
                3.466715011758965
            ]
        },
        {
            "name": "Jeffrey Gill",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.7456787584975508,
                2.7787935153509213,
                3.5475689969900164,
                3.5745850661914296
            ]
        },
        {
            "name": "Amy Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.147152577917886,
                6.381720021732598,
                2.4807105585129015,
                7.5268487336189285
            ]
        },
        {
            "name": "Benjamin Allen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.602597337984475,
                2.9446386116242094,
                7.691489545612295,
                5.83256189240916
            ]
        },
        {
            "name": "John Hobbs",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.258880072913435,
                8.415871772583847,
                5.320434138372045,
                8.385483526688336
            ]
        },
        {
            "name": "Kristin Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.2408004747809724,
                4.816785678291136,
                9.567544461812739,
                6.222219215252503
            ]
        },
        {
            "name": "Brianna Lozano",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.359703749730554,
                5.712448722441784,
                0.901993352176617,
                1.8016360976933048
            ]
        },
        {
            "name": "Rebecca Ortega",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                8.0,
                3.0,
                6.0
            ]
        },
        {
            "name": "Melissa Landry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.397773149071165,
                2.2113651051237277,
                5.20131009197403,
                5.505069308214785
            ]
        },
        {
            "name": "Mark Mercado",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                0.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Eric Duran",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.367053105094532,
                3.2988153628999517,
                5.905302973677225,
                4.242669460879109
            ]
        },
        {
            "name": "Diane Jackson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.22935992399902,
                3.4954634596002068,
                6.254934680637097,
                9.993025713273616
            ]
        },
        {
            "name": "Kathleen Mckay",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                9.847656172783864,
                0.9588413811307207,
                0.5761516428277319,
                3.1604460427083914
            ]
        },
        {
            "name": "Jason Nichols",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.45973358735579994,
                5.640735734417021,
                2.962810523685959,
                5.166391732264723
            ]
        },
        {
            "name": "Rebecca Pruitt",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.6843106089896678,
                1.3647170565211795,
                1.795543261309541,
                0.9124980663226485
            ]
        },
        {
            "name": "Susan Blair",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.6838858928960545,
                2.737456735702632,
                8.179553426208837,
                8.914408336423495
            ]
        },
        {
            "name": "Paul Rivera",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.0418218244781254,
                7.974501751480707,
                7.175621947375001,
                1.0211170309891695
            ]
        },
        {
            "name": "Jeremy Casey",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                3.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Raymond Garcia",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Jonathan Mills",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.77308101006687,
                0.4241587856558503,
                5.8671967492718,
                8.922592098284785
            ]
        },
        {
            "name": "Rebecca Hobbs",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.1274450102281148,
                4.6847523438277445,
                3.4222442715468286,
                7.733097649810389
            ]
        },
        {
            "name": "Levi Burke",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.749473438801909,
                4.997002342882524,
                7.1899959676540215,
                3.3616858734413646
            ]
        },
        {
            "name": "Jasmine Keller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.561282066581873,
                1.8193642554047331,
                3.506359029769312,
                7.307422253857131
            ]
        },
        {
            "name": "Jason Marsh",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.824994809430753,
                8.665549583156965,
                6.880885933120031,
                7.865828404159818
            ]
        },
        {
            "name": "Brett Howard",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.559095320116123,
                4.296242456363617,
                9.672189964823822,
                9.986661061742444
            ]
        },
        {
            "name": "Joel Shaw",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Mitchell Cole",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.548886770192088,
                9.50781756095542,
                9.004999884949227,
                1.5466893947599822
            ]
        },
        {
            "name": "Steven Lewis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.409711941047766,
                1.8404029313734513,
                7.8876840646275115,
                7.426816562531751
            ]
        },
        {
            "name": "Gordon Buck",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                2.0,
                7.0
            ]
        },
        {
            "name": "Sean Holland",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.307077809397919,
                6.8055122734720594,
                9.218232141206613,
                9.91390499264736
            ]
        },
        {
            "name": "Sandra Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.9070908195907745,
                7.97628437098671,
                9.445375753536705,
                6.141278365659471
            ]
        },
        {
            "name": "Timothy Riley",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Yvonne Hughes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.552585259824135,
                5.59488788233148,
                4.546924708326987,
                8.418197556582092
            ]
        },
        {
            "name": "Kyle Davis",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.976894877848937,
                7.044916956113244,
                5.657246611042495,
                4.614423914409342
            ]
        },
        {
            "name": "Brett Mcclure",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.2269532991055871,
                1.3430551974213,
                3.7876234991661772,
                3.3971618724963637
            ]
        },
        {
            "name": "Daniel Brewer",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                9.0,
                9.0,
                8.0,
                0.0
            ]
        },
        {
            "name": "Rick Hammond",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                7.0,
                1.0,
                8.0
            ]
        },
        {
            "name": "Sandra Hall",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.774350728407828,
                4.364999995335491,
                8.149250131448781,
                8.466926994687544
            ]
        },
        {
            "name": "Sara George",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.277368116482831,
                6.413189150553984,
                9.566867633646678,
                6.908484670617193
            ]
        },
        {
            "name": "William Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.380896741808899,
                7.464521923991889,
                7.128494244936086,
                4.558245448758982
            ]
        },
        {
            "name": "Oscar Watson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.265723284741777,
                8.90022343588602,
                3.121203506543646,
                7.155897052893636
            ]
        },
        {
            "name": "April Porter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.004198857105632,
                8.584496759905262,
                6.570030624044292,
                7.1589735369899286
            ]
        },
        {
            "name": "Heather Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.4122458869929778,
                7.6912184456000325,
                8.041424679814877,
                2.861545006679247
            ]
        },
        {
            "name": "Michele Evans",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.797884151663114,
                9.880818709499234,
                7.777546505614827,
                6.008610431293237
            ]
        },
        {
            "name": "Sharon Johnson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.2956958404674432,
                5.859169608423964,
                4.7738874467978265,
                4.058951255109852
            ]
        },
        {
            "name": "Mark Brady",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                5.0,
                8.0
            ]
        },
        {
            "name": "Tammy Espinoza",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                0.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "Caleb Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.997979325783051,
                9.897771887037353,
                7.811212876284074,
                2.828959268643805
            ]
        },
        {
            "name": "James Santos",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.225734791568935,
                5.963958552897949,
                2.1899431411864234,
                6.194231055234576
            ]
        },
        {
            "name": "Tyler Carr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.532149772133075,
                1.5569363442555082,
                8.245565793176203,
                8.634741882553215
            ]
        },
        {
            "name": "David Kennedy",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                5.0,
                4.0
            ]
        },
        {
            "name": "Emily Alvarado",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.0991537771143545,
                9.240408545541666,
                1.5270603180832638,
                8.118970162723825
            ]
        },
        {
            "name": "Evelyn Combs",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                8.0,
                6.0
            ]
        },
        {
            "name": "Lisa Riley",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                8.0,
                3.0,
                2.0
            ]
        },
        {
            "name": "Kristen Ball",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.854255282495918,
                3.9123316144144846,
                7.070900612734249,
                8.47152983282468
            ]
        },
        {
            "name": "Nathan Wallace",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.5165278120648376,
                1.3491924712900167,
                6.774753320900674,
                8.867239191544954
            ]
        },
        {
            "name": "Kim Jones",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                4.0,
                4.0
            ]
        },
        {
            "name": "John Phillips",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.238938771908952,
                7.2696603836926466,
                5.107977870200954,
                5.7182770528629145
            ]
        },
        {
            "name": "Jill Coleman",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                8.0,
                3.0
            ]
        },
        {
            "name": "Bradley Hebert",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.948809675579387,
                4.595142074666669,
                3.408809470533047,
                8.481652977540294
            ]
        },
        {
            "name": "Kelly Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.5538394663061106,
                4.822662077095059,
                7.511047491428775,
                8.900275785016078
            ]
        },
        {
            "name": "Sean Mullen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.630894335369586,
                2.6879280253434654,
                8.30020711119273,
                8.307201237308506
            ]
        },
        {
            "name": "Keith Mclean",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                0.0,
                8.0
            ]
        },
        {
            "name": "Robin Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.9105418500778373,
                7.4920942252743945,
                8.85094928303361,
                9.789442613377705
            ]
        },
        {
            "name": "Brandon Newman",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                8.0,
                9.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Paul Kelly",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.139995393755285,
                8.21087726351333,
                5.084861745807588,
                5.005120161073272
            ]
        },
        {
            "name": "Melissa Stone",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Chad Suarez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.9840529428944027,
                5.058268322775992,
                3.2077621000329213,
                3.40682122597495
            ]
        },
        {
            "name": "Daniel Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.167663862202684,
                7.739137123469128,
                0.9848176802426485,
                7.867317572917592
            ]
        },
        {
            "name": "Chad Johnston",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.347208617187064,
                9.82517606057251,
                6.2991228462985145,
                1.166646911305567
            ]
        },
        {
            "name": "Lauren Jenkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.131952925876604,
                2.478502085562388,
                9.64943642745188,
                8.06059361972323
            ]
        },
        {
            "name": "Jessica Maddox",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Michele Perez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.560431119967308,
                6.972809373116338,
                5.814570672956934,
                3.5122469947960546
            ]
        },
        {
            "name": "Diana Fox",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.101247784995634,
                2.5108347832075237,
                5.299348704478735,
                9.212149086248493
            ]
        },
        {
            "name": "Isaac Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                7.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "Joshua Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.154140047274477,
                7.362164254892809,
                9.81664213661309,
                9.891251234403258
            ]
        },
        {
            "name": "Carlos Barton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.757083719642404,
                4.274919900947563,
                6.0310137915187845,
                0.8571416997009517
            ]
        },
        {
            "name": "Meagan Romero",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.1371645907185892,
                5.085906048868836,
                2.908265005322141,
                7.181728220057907
            ]
        },
        {
            "name": "Sandra Simmons",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                3.0,
                4.0,
                2.0
            ]
        },
        {
            "name": "Amy Bryant",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.394934420876542,
                6.666959042536297,
                5.47823538752805,
                3.458732272381835
            ]
        },
        {
            "name": "Veronica King",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.802198884620777,
                8.630258579930214,
                8.877773455680853,
                5.349258405829513
            ]
        },
        {
            "name": "Alexis Mueller",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                4.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Terry Smith",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                3.0,
                6.0
            ]
        },
        {
            "name": "Dawn Mcguire",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.37441264213555,
                8.826849449231162,
                9.55626449673716,
                3.3860580248450924
            ]
        },
        {
            "name": "Lisa Barker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.766473766639676,
                3.8848482192836,
                5.053661936123994,
                3.0899553526948687
            ]
        },
        {
            "name": "Angela Wells",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.3261901098943385,
                5.173197559953465,
                9.616117021064248,
                5.172861394822913
            ]
        },
        {
            "name": "Jared Norris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.738550677151512,
                4.68470128572257,
                2.986683820171365,
                4.525911995284885
            ]
        },
        {
            "name": "Patty Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.331465704650483,
                7.822400823988982,
                9.167748595121472,
                4.349588591443074
            ]
        },
        {
            "name": "Jeremy Kelly",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                3.0,
                0.0,
                6.0
            ]
        },
        {
            "name": "Joshua Arroyo",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.334615784008806,
                9.131051963506325,
                2.591241206958976,
                5.048867730189509
            ]
        },
        {
            "name": "James Flores",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.511468533962998,
                5.1502389468334115,
                7.28714184892757,
                1.211326066067993
            ]
        },
        {
            "name": "Kristina Rice",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Laura Walker",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.162222101925183,
                8.708221300177838,
                8.404677406560273,
                5.861850606068901
            ]
        },
        {
            "name": "Todd Warren",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Renee Guzman",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.2541562071526102,
                5.801525425723906,
                2.661920831604036,
                0.5274771700707291
            ]
        },
        {
            "name": "Amy Ballard",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                2.0,
                6.0
            ]
        },
        {
            "name": "Rachel Owens",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.328397776543237,
                1.6358139946243535,
                6.11533257105846,
                3.6683448351888726
            ]
        },
        {
            "name": "Deborah Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.181604031992205,
                6.211930613863428,
                2.127112401867959,
                8.23371881630807
            ]
        },
        {
            "name": "James Cain",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                2.0,
                3.0,
                8.0
            ]
        },
        {
            "name": "Kirsten Mason",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.83836774733276,
                9.239578012423554,
                3.296086833676712,
                4.153788256194486
            ]
        },
        {
            "name": "Jose Molina",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Brian Wheeler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.7248497180422735,
                9.369336898770593,
                7.8507304604941215,
                2.7157393327116814
            ]
        },
        {
            "name": "Steven Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.421695301471175,
                1.6143503182780827,
                2.679475867307924,
                9.717239871314177
            ]
        },
        {
            "name": "Thomas Ritter",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                7.0,
                8.0
            ]
        },
        {
            "name": "Carl Maddox",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.85169569328996,
                2.733875809965162,
                9.904814993723864,
                6.912233770768166
            ]
        },
        {
            "name": "Teresa Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.441540547260441,
                5.277656192684839,
                4.034470245690595,
                7.126056597112162
            ]
        },
        {
            "name": "David Campbell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.037647086949927,
                4.091320792465597,
                7.605963054942095,
                2.0053359867110547
            ]
        },
        {
            "name": "Amy Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.918580850120386,
                7.556323485353122,
                2.962072267069603,
                4.9384255698360295
            ]
        },
        {
            "name": "James Young",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.8080086215021804,
                9.726514547690007,
                5.5582581421458865,
                3.4877711158593834
            ]
        },
        {
            "name": "Nancy Green",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                9.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Sandra Poole",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.070575173064155,
                8.74883120042403,
                4.159004495243122,
                5.597238977507846
            ]
        },
        {
            "name": "Aaron Bautista",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.582094366340142,
                7.295445514062045,
                2.8510530551674114,
                3.186936210093014
            ]
        },
        {
            "name": "Deborah Campos",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                9.0,
                1.0
            ]
        },
        {
            "name": "Kyle Torres",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                0.0,
                5.0,
                1.0
            ]
        },
        {
            "name": "Amanda Green",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Nicole Bailey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.304335920530104,
                6.147239664285254,
                9.171626066837547,
                9.313475798909206
            ]
        },
        {
            "name": "Shaun Carroll",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.495182213182495,
                7.397461970386956,
                3.528977427160439,
                4.559978152993678
            ]
        },
        {
            "name": "Alexis Oliver",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.773108924563976,
                4.919011053246451,
                2.5826552217367897,
                8.885516468507555
            ]
        },
        {
            "name": "Vincent Conway",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.665407411836593,
                9.185766113150342,
                9.178870265228715,
                5.236913094906247
            ]
        },
        {
            "name": "Michael Hanna",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                7.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "Carrie Carey",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                8.0,
                2.0,
                6.0
            ]
        },
        {
            "name": "Brian Lee",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                4.0,
                3.0
            ]
        },
        {
            "name": "Angela Tucker",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                2.0,
                1.0,
                6.0
            ]
        },
        {
            "name": "Kathryn Jensen",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.8791824217238546,
                2.642114821616955,
                0.34918183586696305,
                7.948578078882092
            ]
        },
        {
            "name": "Karen Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.732229767556127,
                7.267912242457526,
                9.013088851592952,
                4.185329178705238
            ]
        },
        {
            "name": "Tina Mccarty",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Deanna Spence",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.519073687902454,
                2.5036478036178855,
                6.529394141895841,
                3.5706679959200986
            ]
        },
        {
            "name": "Mary Carr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.086628793876003,
                4.088873950222151,
                7.593205807168206,
                4.947943310601816
            ]
        },
        {
            "name": "Deborah Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.596449868401538,
                8.84878581709047,
                6.910666350934798,
                6.9973351435881215
            ]
        },
        {
            "name": "William Porter",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.2313871031481725,
                4.324234130350783,
                0.7482400781996419,
                2.1831671016370544
            ]
        },
        {
            "name": "Anne Rodriguez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.990970652858059,
                4.235696041095001,
                7.755130729671146,
                8.332429039332048
            ]
        },
        {
            "name": "Autumn Brady",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.962312440650853,
                1.528988516665931,
                8.310425353922717,
                2.718540263901624
            ]
        },
        {
            "name": "Roy Young",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                0.0,
                4.0,
                7.0
            ]
        },
        {
            "name": "Andrew Fowler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.0418037933704318,
                9.311323862219348,
                5.494840359249263,
                7.422773652446839
            ]
        },
        {
            "name": "Nancy Crane",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.758227277146675,
                9.87534016337069,
                3.9411309788896154,
                6.814590770846327
            ]
        },
        {
            "name": "Mark Romero",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.795514399915605,
                8.380978593295549,
                8.49526942761154,
                8.387100034243648
            ]
        },
        {
            "name": "Andrew Bernard",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.6193638274172687,
                9.661632359137396,
                5.9293461712861015,
                6.215798505826296
            ]
        },
        {
            "name": "Carol Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.621588275005142,
                9.872589140457508,
                8.46378294073672,
                2.260881172885398
            ]
        },
        {
            "name": "Jacob Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.941674342593558,
                6.915018896030373,
                9.882525990548316,
                7.776667977828006
            ]
        },
        {
            "name": "Daniel Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.057381061548388,
                8.810704761239492,
                4.8413972010702375,
                8.674406610124532
            ]
        },
        {
            "name": "Thomas Nelson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.6245034298078425,
                1.2994959811016071,
                0.4796861150352233,
                7.368174710200895
            ]
        },
        {
            "name": "Amy Aguilar",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.4805444554218745,
                7.35357968921841,
                7.209004789398059,
                3.7577265466916816
            ]
        },
        {
            "name": "Billy Sanchez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.045803970238963,
                0.337137002905209,
                6.060647475467535,
                2.0807408753370695
            ]
        },
        {
            "name": "Scott Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.642285490244428,
                5.214934523532545,
                4.86758905042778,
                7.604996360358496
            ]
        },
        {
            "name": "Regina Hodges",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.873672014332973,
                2.593334918193153,
                5.640752777577372,
                2.934888322119113
            ]
        },
        {
            "name": "April Roberts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.510767577853844,
                8.324541185072453,
                2.915131194255729,
                9.615673872004688
            ]
        },
        {
            "name": "Jason Franco",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.655160694741454,
                6.7129316136756945,
                7.032691317339542,
                3.773747529054612
            ]
        },
        {
            "name": "Robert Jordan",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.16126000125168,
                8.589329033171952,
                4.316104115919022,
                9.123083598072663
            ]
        },
        {
            "name": "Casey Porter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.3322695859551095,
                4.937018589046874,
                5.015684137948174,
                5.733045549517284
            ]
        },
        {
            "name": "Paige Medina",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                0.0,
                4.0,
                8.0
            ]
        },
        {
            "name": "David Simmons",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.757350154291052,
                6.0134721671563005,
                4.536155619543283,
                3.8334309869773477
            ]
        },
        {
            "name": "Sharon Clark",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.3698956136176745,
                7.6571084014225645,
                7.535407952184299,
                6.627366986885389
            ]
        },
        {
            "name": "Alicia Floyd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.7425329049953815,
                7.768207693930298,
                7.237803921010361,
                6.462440699983763
            ]
        },
        {
            "name": "Hannah Huff",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.513973085786567,
                6.311101430598568,
                5.6360662702280795,
                2.61375293265968
            ]
        },
        {
            "name": "Leslie Hobbs",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.30794490110106,
                3.897538938746046,
                3.539091606753445,
                8.549341494717043
            ]
        },
        {
            "name": "Tracy Barry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.353368991065174,
                2.760759552489098,
                5.257874523812043,
                8.760339330391714
            ]
        },
        {
            "name": "Michael Ware",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                8.0,
                5.0
            ]
        },
        {
            "name": "Matthew Parks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.56616668160421,
                7.0411791197842195,
                6.987860315457519,
                4.1792051835399775
            ]
        },
        {
            "name": "Tina Weaver",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Jessica Moore",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                8.0,
                4.0
            ]
        },
        {
            "name": "Darryl Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.985773547749803,
                6.133762911937044,
                4.184044178860204,
                5.795066903000672
            ]
        },
        {
            "name": "Mike Jones",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.8388218310210345,
                2.1502403284424902,
                3.786790052723177,
                2.0964818938196776
            ]
        },
        {
            "name": "Juan Sims",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.1061652015990635,
                2.027292460026365,
                7.806057640872398,
                8.485958056747165
            ]
        },
        {
            "name": "Aaron Lloyd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.687497472496796,
                5.205419698957433,
                8.58887969458605,
                9.67375237720759
            ]
        },
        {
            "name": "Janice Love",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.400328415572,
                9.096120803299499,
                9.953122837283775,
                4.067037112719792
            ]
        },
        {
            "name": "Joseph Mcguire",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Carolyn Davis",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.767233358859675,
                9.908412309778038,
                5.664428144654668,
                4.387009637559721
            ]
        },
        {
            "name": "Kevin Suarez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                3.0,
                3.0,
                4.0
            ]
        },
        {
            "name": "Nancy Mcguire",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.225350060131412,
                9.765191227635137,
                9.05544511122417,
                5.8831911668422245
            ]
        },
        {
            "name": "Karen Farrell",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                6.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Brianna Wood",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                1.0,
                7.0
            ]
        },
        {
            "name": "Rebecca Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.311655343734301,
                9.98478538449441,
                1.6397358368530686,
                8.713240176772453
            ]
        },
        {
            "name": "Tammy Soto",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                1.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "Corey Morris",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.478796493687837,
                8.331622691925325,
                3.1786428639491335,
                4.515297268518844
            ]
        },
        {
            "name": "Sarah Barr",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Zachary Vega",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                2.0,
                7.0,
                9.0,
                8.0
            ]
        },
        {
            "name": "Rodney Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.6636771653708615,
                3.1560986090106864,
                6.653865004360836,
                7.412555811277111
            ]
        },
        {
            "name": "John Hernandez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.711287085993922,
                6.642903515059921,
                7.284226458169361,
                5.890830713465719
            ]
        },
        {
            "name": "Dominic Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.03398773654479,
                7.9798338594421905,
                1.818845618351812,
                7.78374964746614
            ]
        },
        {
            "name": "Lauren Sexton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.606347954480675,
                3.029041888151816,
                8.882132127235746,
                0.47415119731028604
            ]
        },
        {
            "name": "Joshua Davies",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.69203392268523,
                5.117642899695063,
                6.847198525971171,
                7.173261637689437
            ]
        },
        {
            "name": "Donna Mathis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.419393652642732,
                8.00941565040083,
                4.6822570694880135,
                8.56469096631564
            ]
        },
        {
            "name": "Jason Wood DDS",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                0.0,
                1.0
            ]
        },
        {
            "name": "Tracy Walls",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.715218951437402,
                6.513931493117653,
                9.673868356164002,
                1.5297176677073077
            ]
        },
        {
            "name": "Natalie Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.729413453801145,
                7.531287439048264,
                8.597531702696603,
                4.591460813017279
            ]
        },
        {
            "name": "Nicole Cannon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.49308498666376593,
                7.990445694539826,
                8.07729216625361,
                0.791097521241934
            ]
        },
        {
            "name": "Tyler Phillips",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                4.0,
                9.0,
                8.0,
                5.0
            ]
        },
        {
            "name": "George Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.84156640115178,
                5.5773123626910515,
                7.778034194228422,
                8.127308513924016
            ]
        },
        {
            "name": "Janet Graham",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                6.0,
                7.0,
                8.0,
                5.0
            ]
        },
        {
            "name": "Angela Mccoy",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                6.0,
                9.0,
                7.0
            ]
        },
        {
            "name": "Cindy Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.927282721961779,
                8.658700424951899,
                9.783067794444685,
                7.806817904264785
            ]
        },
        {
            "name": "David Taylor",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.055722637558572,
                9.271789754806127,
                3.3879348221792656,
                8.494692889527816
            ]
        },
        {
            "name": "Amber Moore",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.406552049221808,
                1.216531757528582,
                8.844329624242933,
                0.11419033210358293
            ]
        },
        {
            "name": "Douglas Little",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.973841699882541,
                9.104470882827151,
                0.7069248162315144,
                1.788782644922934
            ]
        },
        {
            "name": "Sarah Foster",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                1.0,
                2.0,
                9.0
            ]
        },
        {
            "name": "Patrick Love",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                6.0,
                4.0,
                1.0
            ]
        },
        {
            "name": "Sarah Black",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9268002695138544,
                2.6334334553164434,
                7.270756310795115,
                7.7101104540242025
            ]
        },
        {
            "name": "Kylie Wilkins",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                1.0,
                5.0
            ]
        },
        {
            "name": "Amy Boone",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.871212324842619,
                3.3397794338326374,
                1.6623255654936875,
                3.7189747522971626
            ]
        },
        {
            "name": "Cody Bishop",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.5511184249253396,
                9.871140231064752,
                5.677780512087108,
                1.3353376252895317
            ]
        },
        {
            "name": "Sarah Yang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.050181364329781,
                8.645201534565977,
                8.497593721408448,
                5.579169351667611
            ]
        },
        {
            "name": "Drew Ortiz",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                3.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Karen Odom",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                6.0,
                8.0
            ]
        },
        {
            "name": "Hannah Murray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.16863226486723,
                9.752667411603671,
                9.063386717614453,
                2.6644493920421097
            ]
        },
        {
            "name": "Erika Reed",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.8308574953778285,
                0.9437270404049332,
                2.9607336775536144,
                8.858788111617276
            ]
        },
        {
            "name": "Chad James",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                4.0,
                5.0,
                0.0
            ]
        },
        {
            "name": "Ruth Peterson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.305779346566878,
                4.416772412833798,
                6.67234722960467,
                9.240447279515227
            ]
        },
        {
            "name": "Heather Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.799111016384126,
                4.143165161662946,
                4.437465016984285,
                3.9363777415897667
            ]
        },
        {
            "name": "Michelle Smith",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                1.0,
                2.0,
                6.0
            ]
        },
        {
            "name": "Julie Butler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.036395857898154,
                0.4839710276901971,
                6.51501860559909,
                8.702151075472651
            ]
        },
        {
            "name": "Sharon Lutz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.66802060227907,
                9.793634201315456,
                6.972108376715295,
                5.2417512989384365
            ]
        },
        {
            "name": "Lisa Humphrey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.7374323314491598,
                7.122443299467699,
                7.834859432813203,
                7.983540754010461
            ]
        },
        {
            "name": "Troy Payne",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                1.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Jeffrey Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.7557060353174965,
                3.5307437553402004,
                7.25447689195488,
                8.23236654919051
            ]
        },
        {
            "name": "Pamela Good",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.337359175593581,
                9.01872420880027,
                6.297597359046981,
                1.8336945054647489
            ]
        },
        {
            "name": "Amanda Lin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.4344311691830631,
                5.812788299325847,
                4.46223724147495,
                6.854699976580666
            ]
        },
        {
            "name": "Chelsea Porter",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                3.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Andrew Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.392983151609303,
                6.0629345890357325,
                2.2824693624920864,
                6.092210712622325
            ]
        },
        {
            "name": "Phyllis Hudson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.541860689554025,
                5.017008213837753,
                9.220746699706714,
                4.553300917436174
            ]
        },
        {
            "name": "Brian Massey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.290546641603716,
                8.108486466199613,
                4.984073358295478,
                3.0997502715272556
            ]
        },
        {
            "name": "Kimberly Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.714902695134165,
                8.552404490404527,
                8.484641546243134,
                7.240473010870046
            ]
        },
        {
            "name": "Michael Mckay",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                9.0,
                0.0
            ]
        },
        {
            "name": "Troy Barnes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                8.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Lindsey Simon",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.1709219979376435,
                4.8923400618705255,
                7.240964424300907,
                9.06653786928229
            ]
        },
        {
            "name": "Jonathan Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.726631834749828,
                8.848125719396403,
                9.491478124309749,
                4.209223102599079
            ]
        },
        {
            "name": "Laura Lawrence",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.60195720998635,
                3.7344564725298306,
                9.442527191343592,
                0.41024744456734263
            ]
        },
        {
            "name": "David Foster",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.664039685858173,
                8.669078959417392,
                6.112066566182684,
                6.8051328086512894
            ]
        },
        {
            "name": "Kelsey Ochoa",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.595032878276069,
                9.12365618172299,
                9.971098258353134,
                7.033832109438657
            ]
        },
        {
            "name": "Mario Noble",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.163242240522003,
                9.78988201562777,
                3.96267719099965,
                4.708997020530777
            ]
        },
        {
            "name": "John Cortez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Marie Mcknight",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.392999088928394,
                9.205794010430393,
                4.095737000401035,
                3.4841745284932046
            ]
        },
        {
            "name": "Kelly Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.81505803715008,
                8.631599953958332,
                1.4608014596765482,
                8.480623983290387
            ]
        },
        {
            "name": "Michele Franco",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.154075123069001,
                4.339923129885937,
                6.746570698699962,
                6.143626732108848
            ]
        },
        {
            "name": "Amanda Conner",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                7.0,
                7.0,
                5.0,
                7.0
            ]
        },
        {
            "name": "John Scott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.264480583742397,
                6.683525792007781,
                5.4103637756416365,
                7.474501624751389
            ]
        },
        {
            "name": "Miguel Cuevas",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                7.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Maria Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.946842937383484,
                2.301891985971887,
                4.562641416018101,
                9.921956695797299
            ]
        },
        {
            "name": "Scott Simmons",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.237777121536755,
                9.746142606299028,
                8.466168570562765,
                9.60430970385789
            ]
        },
        {
            "name": "Melinda Wells",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.1048412348615875,
                2.036127239305549,
                8.446479631671416,
                4.181693860720631
            ]
        },
        {
            "name": "Laura Lozano",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                3.0,
                0.0,
                8.0
            ]
        },
        {
            "name": "David Huffman",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                6.0,
                8.0,
                8.0
            ]
        },
        {
            "name": "David Merritt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.849137951434896,
                3.1896598264143323,
                8.25385398132265,
                7.671664084654669
            ]
        },
        {
            "name": "Samuel Dodson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                6.0,
                2.0,
                3.0
            ]
        },
        {
            "name": "Levi Barrett",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.663771062987608,
                8.279424217937512,
                4.307995010544584,
                2.2557599268650343
            ]
        },
        {
            "name": "Sandra Cannon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.139901307644751,
                9.54677799357928,
                5.148300040818336,
                7.986338166957366
            ]
        },
        {
            "name": "Gary Castillo",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.031919215991968,
                9.906130670941234,
                4.786570412645874,
                2.655343209012033
            ]
        },
        {
            "name": "Christy Hall",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Sandra Torres",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7330757403623265,
                3.860955891352538,
                4.315991058606733,
                6.286840480346507
            ]
        },
        {
            "name": "Connor Tanner",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.038537179253866,
                9.931951407174482,
                5.935121816719996,
                2.4295067131304595
            ]
        },
        {
            "name": "Laura Gibson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.769219612578953,
                8.670019229030709,
                3.6966241619610423,
                0.06273370573608382
            ]
        },
        {
            "name": "Thomas Moyer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.8899793607324735,
                6.086806773844517,
                5.860922057758691,
                3.0538453327315684
            ]
        },
        {
            "name": "Betty Jenkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.132365698605135,
                9.282095998101276,
                5.950536104542296,
                0.8288244584893499
            ]
        },
        {
            "name": "Parker Rivera",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.308336105469365,
                2.0734218268244247,
                9.416447936725174,
                8.879540585810515
            ]
        },
        {
            "name": "Lindsey Lam",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                3.0,
                9.0,
                4.0
            ]
        },
        {
            "name": "Jeffrey Beck",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Crystal Fox",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2779013905281866,
                1.803034208357646,
                9.816628092730301,
                5.783480571521897
            ]
        },
        {
            "name": "Heather Jensen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.137582778692617,
                2.6261425972478203,
                4.9511240565271155,
                6.030735054430949
            ]
        },
        {
            "name": "Mia Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.8256297127134475,
                1.2872673701449935,
                7.791749072033198,
                7.51039317471564
            ]
        },
        {
            "name": "Herbert Pruitt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.8800926711637085,
                5.609412604898889,
                4.174655264507946,
                8.3040332106133
            ]
        },
        {
            "name": "Jason Wilson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                0.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "Brad Flowers",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.824158004894713,
                7.651503754177326,
                4.149320199668177,
                3.268734651909803
            ]
        },
        {
            "name": "Jordan Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.17572954498231,
                6.369675201744471,
                9.316877524243505,
                4.784093385974862
            ]
        },
        {
            "name": "Ashley Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.213768134123589,
                2.5166199799227575,
                3.6872922147620146,
                3.79014376429938
            ]
        },
        {
            "name": "Julie Anderson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Denise Santos",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.906646464637722,
                3.657500935809368,
                2.2391966604031315,
                1.8163530971647126
            ]
        },
        {
            "name": "Daniel Carter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.878066982289745,
                6.782973225553785,
                6.047088673360195,
                7.740303007708265
            ]
        },
        {
            "name": "David Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.062213102536536,
                3.70738770401849,
                8.43085948205734,
                8.084571979584432
            ]
        },
        {
            "name": "Natalie Hill",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Ian Reyes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.731698150634188,
                8.125932303534544,
                4.583224653906143,
                8.780107128321525
            ]
        },
        {
            "name": "Todd Farmer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.9820320480576799,
                7.3201044754528555,
                7.480545262442511,
                5.913560431623047
            ]
        },
        {
            "name": "Brandi Dean",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.632057741424926,
                3.1302926279129144,
                0.906099517815468,
                5.91337919816495
            ]
        },
        {
            "name": "Amy Fuller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.068115931838911,
                8.5779458536324,
                8.094226267821128,
                9.777135618094219
            ]
        },
        {
            "name": "Katie Bean",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.91646292823242,
                6.404750068787307,
                7.139779472077585,
                2.3618285940900394
            ]
        },
        {
            "name": "Taylor Brown",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                6.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Thomas Boyd",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.222037459549057,
                9.658597544813967,
                8.322215001471578,
                8.123038606163306
            ]
        },
        {
            "name": "Lori Wilkinson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                7.0,
                0.0
            ]
        },
        {
            "name": "Amy Davenport",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.848803071398553,
                4.396216215494361,
                9.190584723735613,
                1.5975534413822614
            ]
        },
        {
            "name": "Victor Miles",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.809920560370485,
                3.77985654716967,
                7.007728574747809,
                4.072925917084968
            ]
        },
        {
            "name": "Matthew Chen",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                6.5383410121877965,
                2.8107421268410446,
                3.274617490675035,
                3.188122205394397
            ]
        },
        {
            "name": "Jennifer Perez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.548792394691775,
                1.2991837466053677,
                3.537062021597954,
                8.809080169976896
            ]
        },
        {
            "name": "Justin Scott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.2556540206221745,
                8.87201209764611,
                8.753570613466668,
                2.751358513882609
            ]
        },
        {
            "name": "Lynn Wang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.139006374718305,
                6.279948962541864,
                1.7987650391363352,
                1.8806247027227059
            ]
        },
        {
            "name": "Amy Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.967493465527333,
                4.715288066805136,
                0.04347734070524242,
                4.572411180586543
            ]
        },
        {
            "name": "Benjamin Owens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.892310466184735,
                7.030276603427908,
                7.92777085644846,
                4.923289997668573
            ]
        },
        {
            "name": "Angel Scott",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.228160157845722,
                0.5926792472708197,
                4.474722952958643,
                2.6474356832629855
            ]
        },
        {
            "name": "Thomas Vega",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.921304349036902,
                2.0155264489847697,
                9.013601983286131,
                9.853564578446601
            ]
        },
        {
            "name": "Monique Barry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.618664079820519,
                4.688411384107412,
                9.960396809799013,
                3.476461133568228
            ]
        },
        {
            "name": "Lisa Williams",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2323544623851637,
                6.382188263043775,
                8.39570960069318,
                8.67292284138211
            ]
        },
        {
            "name": "Arthur Pham",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.185014805143359,
                3.101285313888382,
                3.3538605566293027,
                1.5789861757417416
            ]
        },
        {
            "name": "Laura Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.540207821923403,
                9.764806599968676,
                9.627157382412127,
                9.090413618190302
            ]
        },
        {
            "name": "Nicole Morris",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.7631159575633346,
                9.54283317208105,
                0.9755413137604231,
                6.464183976417733
            ]
        },
        {
            "name": "Jenny Oconnor",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                0.0,
                8.0,
                5.0
            ]
        },
        {
            "name": "Paul Coleman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.191103092225653,
                8.906840524289981,
                9.040621996051891,
                9.531997924508843
            ]
        },
        {
            "name": "Michael Jensen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.21081816000669287,
                6.312822514301441,
                5.977517300710816,
                7.165227437347377
            ]
        },
        {
            "name": "Elizabeth Lee",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                3.0,
                4.0
            ]
        },
        {
            "name": "Thomas Obrien",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.625695270827975,
                2.242117992715787,
                3.4452198351501035,
                3.043835772521206
            ]
        },
        {
            "name": "Steven Oliver",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.9864684745692385,
                3.6667365203713933,
                6.968940544553508,
                9.992438291487666
            ]
        },
        {
            "name": "Jennifer Avila",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.801240637300154,
                9.725928420718066,
                9.803036103223143,
                9.517542194559441
            ]
        },
        {
            "name": "Adam Avila",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                9.0,
                0.0,
                3.0
            ]
        },
        {
            "name": "Nicholas Gibbs",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.154056203550494,
                9.873596860420419,
                9.532393224390908,
                3.056092924756648
            ]
        },
        {
            "name": "Vincent Hunter",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Nicholas Carr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.74943945249428,
                7.644517545561296,
                8.891712149953742,
                2.7609352979459487
            ]
        },
        {
            "name": "Ryan Thornton",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                9.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Kenneth Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.631999774381303,
                8.422054626507782,
                3.7384708729578326,
                8.72921006971637
            ]
        },
        {
            "name": "Paula Beasley",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                7.0,
                6.0
            ]
        },
        {
            "name": "Jill Lewis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.9814982799977987,
                7.650881830566774,
                1.997569693023091,
                8.885562281390683
            ]
        },
        {
            "name": "Timothy Moore",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                6.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "Tanner Gordon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.840947777356589,
                7.5027353727681145,
                8.825419084414516,
                9.285958059684924
            ]
        },
        {
            "name": "Katie Schmitt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.775723487425347,
                9.434824612382961,
                7.692005450353586,
                3.0308663691831654
            ]
        },
        {
            "name": "Mary Rose",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.8549373032711732,
                2.635640573280573,
                7.068539683781502,
                9.282778846177665
            ]
        },
        {
            "name": "Carl Fowler",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.57320095097716,
                6.427076097284661,
                3.0943352710971994,
                8.061529675988963
            ]
        },
        {
            "name": "Barbara Green",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                6.0,
                5.0,
                7.0,
                9.0
            ]
        },
        {
            "name": "Mary Mack",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.917465381272094,
                5.708677043512599,
                9.403541113680951,
                5.116938903019362
            ]
        },
        {
            "name": "Cassidy Cline",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.351669048268937,
                7.660959945756036,
                1.8787481369134031,
                5.097787939305132
            ]
        },
        {
            "name": "Kevin Ross",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.509365497342802,
                7.3084974912914555,
                3.7701412289078178,
                8.881551329306669
            ]
        },
        {
            "name": "Norman Baird",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.34511930249511297,
                2.725774496671613,
                6.994718165368105,
                7.16965420638788
            ]
        },
        {
            "name": "Scott Berry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.334948247308185,
                3.1824903195353436,
                6.226252834644769,
                7.806660621060606
            ]
        },
        {
            "name": "Richard Shaw",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.5050172781223794,
                0.8391054795990012,
                4.44084230404847,
                1.2984076283107828
            ]
        },
        {
            "name": "Jessica Barnes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.8000630701834783,
                3.9131030513289096,
                6.650092977065966,
                8.308993518663137
            ]
        },
        {
            "name": "Kari Watson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                0.0,
                8.0,
                8.0
            ]
        },
        {
            "name": "Carol Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.525185599874149,
                3.989948999369597,
                4.248219663545859,
                3.9332328237676535
            ]
        },
        {
            "name": "Jason Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.679943267967246,
                7.970028372437814,
                7.538784660982745,
                2.783482904375739
            ]
        },
        {
            "name": "Kevin Harris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.170676418792478,
                9.977524606655875,
                3.807518454142429,
                5.511182708503868
            ]
        },
        {
            "name": "Lacey Matthews",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.211600142644023,
                8.708475663212319,
                8.019674614161577,
                8.911967976255397
            ]
        },
        {
            "name": "Samantha Nunez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.90220232661936,
                0.4434792013209836,
                7.241340236393543,
                5.023166061474819
            ]
        },
        {
            "name": "Tina Scott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.909576952480375,
                6.5815988045083476,
                7.555530630313262,
                5.087442709516187
            ]
        },
        {
            "name": "Lydia Burton",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                1.0,
                4.0,
                0.0
            ]
        },
        {
            "name": "Tracie Lopez",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Matthew Bruce",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.9419206588775049,
                0.4651763269724073,
                4.523142451644435,
                8.942426331414147
            ]
        },
        {
            "name": "Susan King",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.169155530052098,
                4.282833492258996,
                5.683406873537914,
                8.953978314498816
            ]
        },
        {
            "name": "Grace Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.959135944713138,
                1.88106378412323,
                2.00305301743131,
                7.818380314318139
            ]
        },
        {
            "name": "Karen Mills",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.0267540735036196,
                4.3145396347866285,
                3.181807714578635,
                7.183711062458087
            ]
        },
        {
            "name": "Cheryl Ingram",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.679198980528359,
                8.733788555066097,
                8.001419023461843,
                0.18072828171615224
            ]
        },
        {
            "name": "Ray Todd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.100042114286197,
                6.81757565801492,
                5.384098006874197,
                9.818983084947558
            ]
        },
        {
            "name": "Kaitlyn Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.502450750395391,
                2.136763978749361,
                9.905377226728483,
                8.631361892948075
            ]
        },
        {
            "name": "Kayla James",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.585220782387546,
                2.509428885118625,
                1.8863395492219142,
                6.77067362896003
            ]
        },
        {
            "name": "Ronnie Ramirez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.649189226936047,
                5.335173123647427,
                6.689120448713707,
                7.634407924646789
            ]
        },
        {
            "name": "Rodney Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.4645529472136705,
                9.564359264473923,
                1.92146761718307,
                5.362791519695522
            ]
        },
        {
            "name": "Edwin Valdez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                2.0,
                7.0
            ]
        },
        {
            "name": "Barbara Hunter",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                2.0,
                8.0,
                5.0
            ]
        },
        {
            "name": "Maria Duncan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.276520790343184,
                6.310356320990223,
                6.437087616295008,
                5.593824157219224
            ]
        },
        {
            "name": "Louis Coleman",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                7.0,
                7.0,
                1.0
            ]
        },
        {
            "name": "Ian Santiago",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.2334007843958317,
                0.9756084577318882,
                4.558744506551174,
                5.564672256093609
            ]
        },
        {
            "name": "Debra Bush",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.861179886281917,
                2.728261480333454,
                6.790723645649502,
                3.7398241639518264
            ]
        },
        {
            "name": "Jimmy Hall",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                4.0,
                6.0,
                7.0
            ]
        },
        {
            "name": "Matthew Watson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.595137058450359,
                9.47677760764796,
                3.9760199944295027,
                8.247076725510533
            ]
        },
        {
            "name": "Denise Walker",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.459025728651856,
                9.367554437398699,
                1.5620503156528442,
                8.903684664220537
            ]
        },
        {
            "name": "James Franklin",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.4092429384876572,
                6.1705878630680235,
                4.896715785484673,
                1.4703804742237236
            ]
        },
        {
            "name": "Jay Campbell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.6192739825874405,
                0.5259626531377268,
                9.501528311915065,
                5.3592163800424295
            ]
        },
        {
            "name": "Jennifer Smith",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.3426984283448733,
                1.5955350786546152,
                2.1404031275852433,
                6.371715445923318
            ]
        },
        {
            "name": "Mary Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.977673985418082,
                5.601789903504102,
                5.323438307907336,
                8.812938497097994
            ]
        },
        {
            "name": "Julie Thompson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.807062433694818,
                4.663880422410793,
                4.680580457657583,
                8.248183962807381
            ]
        },
        {
            "name": "Joseph Prince",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                1.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Erica Miranda",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.8245251881650777,
                4.30854261147093,
                6.768770968795251,
                5.225158388267425
            ]
        },
        {
            "name": "Kelly Rivera",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                8.0,
                3.0,
                2.0
            ]
        },
        {
            "name": "Ashley Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.188909168580743,
                6.628453378388893,
                5.269022198322929,
                1.7705208648895099
            ]
        },
        {
            "name": "Jennifer Owen",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                8.0,
                7.0,
                9.0,
                5.0
            ]
        },
        {
            "name": "Joseph Sosa",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.14969974474716,
                6.323265147299138,
                4.809056266132645,
                7.452148410103795
            ]
        },
        {
            "name": "Philip Hood",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.7802658087572585,
                5.349254801766029,
                6.410168825689966,
                6.274481648668827
            ]
        },
        {
            "name": "Donald Fisher",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                2.0,
                1.0,
                6.0
            ]
        },
        {
            "name": "Johnny Nolan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.0841570170252535,
                6.914318536839286,
                2.223206881930078,
                2.4582140125791976
            ]
        },
        {
            "name": "Ivan Alvarez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.459478067648188,
                8.937615862798756,
                8.366555456035659,
                5.6982649330413695
            ]
        },
        {
            "name": "Samuel Roberts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.061728433025212,
                4.689495904126834,
                3.6139362193808946,
                6.057402169107257
            ]
        },
        {
            "name": "James Kelly",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.956490693499344,
                6.880862997508505,
                4.420127045978796,
                3.838992342033065
            ]
        },
        {
            "name": "George Berg",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.7311158636378969,
                4.362558243367017,
                5.142372555516116,
                6.590604242658127
            ]
        },
        {
            "name": "Emma Olsen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.1619906593504785,
                5.536997312386078,
                8.434648339945909,
                2.795957369646538
            ]
        },
        {
            "name": "Mark Reyes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.503367194907375,
                8.019233433707683,
                9.43039213408542,
                4.150656671747899
            ]
        },
        {
            "name": "Kathy Hood",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.069194999238798,
                7.742176793410889,
                8.206846812346697,
                7.241452314662008
            ]
        },
        {
            "name": "Pamela Bray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.070572300125814,
                8.366949382131539,
                8.268812408612469,
                4.881373718514251
            ]
        },
        {
            "name": "Allen Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.512456858450111,
                2.3837421829915204,
                8.028018160640737,
                7.378407204049085
            ]
        },
        {
            "name": "Mary Caldwell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.523954819453383,
                5.647336079229003,
                7.916648609857349,
                8.857611854037145
            ]
        },
        {
            "name": "Haley Ford",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Thomas Mata",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.618501012578125,
                2.5524671925840865,
                3.5629504656216495,
                8.825919180427531
            ]
        },
        {
            "name": "Maria Brown",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.842109249052395,
                9.45700134497292,
                6.5944765147100135,
                4.123295599785914
            ]
        },
        {
            "name": "Johnny Roberts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.292951733519355,
                5.161672636716952,
                5.259774184989431,
                9.482185121234888
            ]
        },
        {
            "name": "Carlos Salazar",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.355438908143661,
                6.749217203874115,
                5.422300119432722,
                5.922649983846768
            ]
        },
        {
            "name": "Kiara Luna",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "James White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                6.0,
                7.0,
                6.0
            ]
        },
        {
            "name": "Diane White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                1.0,
                8.0,
                9.0
            ]
        },
        {
            "name": "Kenneth Perez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Andrea Morales",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "James Castillo",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                8.0,
                0.0
            ]
        },
        {
            "name": "Thomas Silva",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.410978265445767,
                3.7179526074112084,
                9.638984346259905,
                5.87280705474725
            ]
        },
        {
            "name": "Krystal Garza",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                6.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "Brittany Dunn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.237715780478542,
                7.931798417787112,
                8.035307038605255,
                1.831539974344873
            ]
        },
        {
            "name": "Rachel Obrien",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.240877125907849,
                7.424607794824274,
                0.7836021450151873,
                6.358883731498799
            ]
        },
        {
            "name": "Mitchell Bryan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.463198489081165,
                7.871712498129961,
                9.430892257676494,
                6.504216976709362
            ]
        },
        {
            "name": "Shannon Farley",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.1595354968941116,
                8.319235384236114,
                8.797117885804337,
                3.0041530939850114
            ]
        },
        {
            "name": "Mark Sloan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.71389251050465,
                6.8640513149164315,
                1.3076146027665605,
                7.46729098214209
            ]
        },
        {
            "name": "James Kim",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.335804144583889,
                6.512707515184387,
                3.4470077175182894,
                4.09760191797044
            ]
        },
        {
            "name": "Jillian Acosta",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                6.0,
                5.0,
                2.0
            ]
        },
        {
            "name": "Sarah Davis",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.808942444734169,
                2.1844457191914177,
                8.96630462652182,
                1.2193164141547062
            ]
        },
        {
            "name": "Jon Harmon",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.80114176337457,
                5.225904354691883,
                2.239632061320288,
                8.675474515425648
            ]
        },
        {
            "name": "Grace Nelson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.028803683880648,
                8.15318579059678,
                7.570115296499815,
                0.5284265972689652
            ]
        },
        {
            "name": "Jaime Bray",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                2.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Eric Green",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                8.0,
                4.0,
                4.0
            ]
        },
        {
            "name": "Frank Rogers",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.235620298944436,
                0.9070787322650888,
                4.602439966294204,
                7.308241309392437
            ]
        },
        {
            "name": "Tracy Jenkins",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                1.0,
                3.0,
                5.0
            ]
        },
        {
            "name": "Hector Mendoza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.677950998818425,
                3.43069316979085,
                6.760176762692644,
                7.414659184593154
            ]
        },
        {
            "name": "Adam Reed",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.8062049405656984,
                3.8397520010538475,
                8.846416988578769,
                1.1618422657934215
            ]
        },
        {
            "name": "Sharon Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                2.0,
                2.0
            ]
        },
        {
            "name": "Spencer Spears",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.312107149935225,
                7.938801586065915,
                7.216568249928493,
                7.258116302017647
            ]
        },
        {
            "name": "James Snyder",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                2.0,
                6.0,
                2.0
            ]
        },
        {
            "name": "Ross Mcknight",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.270593312097223,
                7.05161143531371,
                5.093627515065993,
                9.56180132530031
            ]
        },
        {
            "name": "Todd Foley DDS",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.968110524571233,
                8.292669026709996,
                9.304512065768062,
                9.751766476837595
            ]
        },
        {
            "name": "Oscar Gonzalez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                3.0,
                6.0,
                0.0
            ]
        },
        {
            "name": "Kenneth Morgan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.36359923801994,
                5.5024415907834365,
                5.254021445582222,
                3.6388927834300535
            ]
        },
        {
            "name": "Danny Harmon",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                1.0,
                9.0
            ]
        },
        {
            "name": "Randy Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.661522011667263,
                5.101366140874026,
                8.816748197712238,
                2.644948848968986
            ]
        },
        {
            "name": "Paul Yang",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                1.0,
                4.0,
                9.0
            ]
        },
        {
            "name": "Kenneth Young",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.156124289834954,
                5.522159808726817,
                3.2895059830748745,
                5.407586117748839
            ]
        },
        {
            "name": "Regina Knight",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.603336380815513,
                2.152974257358769,
                6.770340290134577,
                9.692008403454688
            ]
        },
        {
            "name": "Mark Reid",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                1.0,
                4.0,
                8.0
            ]
        },
        {
            "name": "Misty Gray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.9729191182472606,
                2.2454815475827865,
                8.782790782929997,
                6.658500707848781
            ]
        },
        {
            "name": "Lauren Moore",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.4276934039732754,
                0.5020403760956265,
                5.4335256062885895,
                8.060289654818101
            ]
        },
        {
            "name": "Patricia Jones",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Jamie Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7649334772933294,
                7.681542146610858,
                2.62980393730843,
                8.055524370835608
            ]
        },
        {
            "name": "Thomas Wagner",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                4.0,
                5.0,
                1.0
            ]
        },
        {
            "name": "Zachary Lowe",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.0154694480363293,
                3.0433021651381145,
                7.454646020317098,
                6.022502827909111
            ]
        },
        {
            "name": "Steven Roberts",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.676920201759945,
                5.73448938347158,
                5.435599706529498,
                5.943391690703105
            ]
        },
        {
            "name": "Sarah Perkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.978659473237206,
                8.319778414831397,
                5.471310157321229,
                4.425585844779063
            ]
        },
        {
            "name": "Steven Bonilla",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.129350747345558,
                6.286468194335785,
                7.5146230748952005,
                8.389964427145864
            ]
        },
        {
            "name": "Chelsea Kidd",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.838656611661445,
                0.5556557092763512,
                7.3445388431504615,
                5.796194446136186
            ]
        },
        {
            "name": "Kayla Shaw",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                0.0,
                8.0
            ]
        },
        {
            "name": "Jack Thompson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                6.0,
                1.0
            ]
        },
        {
            "name": "Michael Cruz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.983415608797096,
                9.639437695708962,
                8.72569134350221,
                2.134961244057929
            ]
        },
        {
            "name": "Hailey Hayden",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                9.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Brooke Sawyer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.78645606962246,
                4.411535401112664,
                7.272471252424496,
                5.47738965994621
            ]
        },
        {
            "name": "Melvin Lewis",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                3.0,
                7.0
            ]
        },
        {
            "name": "Susan Peterson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.944303302224686,
                6.945799951315664,
                9.586144398775891,
                6.097881616523704
            ]
        },
        {
            "name": "Brandon Neal",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.525103731903425,
                4.616970481765239,
                8.478602910963666,
                6.632799376333491
            ]
        },
        {
            "name": "Edward Ortiz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.363234307751139,
                5.1913796884354095,
                2.320917998705835,
                2.7561269157203165
            ]
        },
        {
            "name": "Megan Barry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.25714622657078,
                9.336878014544656,
                2.842909099190284,
                7.2732586625283915
            ]
        },
        {
            "name": "David Fritz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.3547748873141716,
                9.943065000644935,
                6.196170536733138,
                5.92646326113305
            ]
        },
        {
            "name": "Susan Alvarado",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.92210499679157,
                5.4701237649954155,
                6.1143994057837325,
                9.676734827251309
            ]
        },
        {
            "name": "Ryan Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.4211607860679365,
                5.9615530480583026,
                2.8242369750100584,
                7.334307502639231
            ]
        },
        {
            "name": "Kelly Trujillo",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.695681141807313,
                9.702037980576216,
                3.188909335010858,
                5.779536744232525
            ]
        },
        {
            "name": "Philip Davis",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.5890427994746332,
                4.61594767457112,
                6.5283156629683905,
                1.3555833641377348
            ]
        },
        {
            "name": "Adrian White",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                4.0,
                2.0
            ]
        },
        {
            "name": "Grace Jensen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.892557587027547,
                3.029275740300557,
                2.843240180292948,
                7.375978562875549
            ]
        },
        {
            "name": "Gerald Velez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.892799132865218,
                6.939842760653447,
                7.875035398310743,
                3.324489930745888
            ]
        },
        {
            "name": "Kimberly Gray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.30272377476982,
                8.884841621091294,
                9.581360998873379,
                1.0574062605044463
            ]
        },
        {
            "name": "Jennifer Olson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.44562238636342,
                8.083006424836205,
                6.214856321790586,
                4.78809159166464
            ]
        },
        {
            "name": "Johnny Kim",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.5410723794506767,
                3.4602366491987766,
                2.2159231986904677,
                5.238368084093894
            ]
        },
        {
            "name": "Hector Sanders",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.83484831064928,
                3.494436167509083,
                9.054602193896773,
                6.7352237051724915
            ]
        },
        {
            "name": "Marc Price",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.52813644977998,
                7.253495390026524,
                2.2367591227531274,
                3.204606232195511
            ]
        },
        {
            "name": "Jordan Nguyen",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                6.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Andrea Jackson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                7.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "Tammy Rangel",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.8278986531542838,
                1.5942655584782115,
                2.0686220457806095,
                3.652510078254207
            ]
        },
        {
            "name": "Cynthia Walker",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                2.0,
                3.0,
                4.0
            ]
        },
        {
            "name": "Lisa Middleton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.3141456161691596,
                0.840215428605776,
                5.843266373255771,
                9.162090417314555
            ]
        },
        {
            "name": "Rebekah White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.29287236324124,
                2.338223584138307,
                4.692689304412855,
                2.2015540767800568
            ]
        },
        {
            "name": "John Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.838014594889486,
                8.717135474808837,
                3.3488365502073707,
                4.088749198019934
            ]
        },
        {
            "name": "Stephen Cain",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8118273769696365,
                6.801316164691514,
                7.261165062741836,
                4.172069142953374
            ]
        },
        {
            "name": "Rebecca Obrien",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.57250780133778,
                6.995089791484306,
                3.3491432897442523,
                8.61673756301802
            ]
        },
        {
            "name": "Derek Horton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.3247136312396197,
                9.685758432778387,
                8.375419256007925,
                8.375613886050184
            ]
        },
        {
            "name": "Anna Vega",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "John Herman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.409573862365383,
                5.226755508984181,
                6.9328886202581765,
                1.698932473775421
            ]
        },
        {
            "name": "Michael Scott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.680243041293993,
                8.665972024017117,
                2.55168472979119,
                8.050195173064864
            ]
        },
        {
            "name": "Douglas Walker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.674048739457537,
                9.744481414530188,
                8.587695739759587,
                5.59579791933448
            ]
        },
        {
            "name": "Jeffery Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                0.0,
                2.0,
                4.0
            ]
        },
        {
            "name": "Kimberly Lee",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.957408466987003,
                3.414358063987444,
                3.831695333585643,
                3.6911590622317476
            ]
        },
        {
            "name": "Daniel Quinn",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.7426718115346829,
                4.133121824950572,
                4.797418420074099,
                3.7065347458335656
            ]
        },
        {
            "name": "Shane Harris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.907971784898625,
                2.0278802161087843,
                4.765550869055404,
                7.23580730674898
            ]
        },
        {
            "name": "Thomas Suarez",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                5.0,
                6.0
            ]
        },
        {
            "name": "Marisa Warren",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                6.0,
                8.0,
                4.0,
                9.0
            ]
        },
        {
            "name": "Albert Rogers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                3.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Megan Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                4.0,
                0.0,
                6.0
            ]
        },
        {
            "name": "Tammy Mcdonald",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.371785159361931,
                4.65293039669367,
                1.3467299559298742,
                7.197323332542551
            ]
        },
        {
            "name": "John Fernandez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.50052414660776,
                9.731338303387384,
                6.888731171577681,
                9.458248064449661
            ]
        },
        {
            "name": "James Olson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.947197843694857,
                4.648009611418283,
                9.79322573095043,
                7.260235673313201
            ]
        },
        {
            "name": "Lori Carr",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.706220418836145,
                9.622197517726818,
                4.291702751351413,
                4.656723811502939
            ]
        },
        {
            "name": "Mark Mason",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.132380296105701,
                6.753710229000069,
                1.0682333147429708,
                2.7776583389703764
            ]
        },
        {
            "name": "William Snyder",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Thomas Turner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.051509746710607,
                7.408538276284123,
                7.458755385563017,
                9.626428240643666
            ]
        },
        {
            "name": "George Nguyen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.247594685805829,
                6.272021746043431,
                5.1919882367703085,
                9.326287143793529
            ]
        },
        {
            "name": "Robert Merritt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.172928153524602,
                7.537509253528336,
                1.2384535892837476,
                9.541905843328282
            ]
        },
        {
            "name": "John Schaefer",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.0751220163727755,
                9.147942207702224,
                7.765571353488,
                4.91911149569443
            ]
        },
        {
            "name": "Thomas Wilson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.2239971550293316,
                8.74591739268459,
                7.119056262729448,
                7.962735696253733
            ]
        },
        {
            "name": "Charles Kim",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.367523275816326,
                2.2846852379322993,
                3.5435111722333206,
                8.447501171993858
            ]
        },
        {
            "name": "Christine Kirk",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Debbie Brooks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.584383374285622,
                7.996378265583603,
                7.524369794573974,
                7.583223030955992
            ]
        },
        {
            "name": "Eugene King",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.288129795237909,
                4.551067001971736,
                7.465164407997072,
                5.606791598691901
            ]
        },
        {
            "name": "Jennifer Lopez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.7266878771170999,
                3.756054241598693,
                2.8521448712976403,
                9.233755176885918
            ]
        },
        {
            "name": "Gina Bishop",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.066135613152243,
                9.953652111984177,
                7.166745158478673,
                0.6891362076246188
            ]
        },
        {
            "name": "Kenneth Mendez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.110539687030465,
                6.767409792535202,
                0.6979790338237023,
                7.093532197531149
            ]
        },
        {
            "name": "Richard Hughes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                5.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Donald Jones",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                0.0,
                0.0
            ]
        },
        {
            "name": "John Lopez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.24102281012955307,
                4.950612822308614,
                4.445678745014531,
                5.233748456634676
            ]
        },
        {
            "name": "Kayla Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.296984337853619,
                7.952145076058138,
                2.6147870947163563,
                7.30616954027616
            ]
        },
        {
            "name": "Deborah Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.616117546461571,
                4.928957064841866,
                2.9410917630311726,
                9.18989110676775
            ]
        },
        {
            "name": "Deborah Pitts",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Robyn West",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.434369438128064,
                0.3167534719815548,
                5.674490751637707,
                8.177005188027119
            ]
        },
        {
            "name": "Teresa Ortiz",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.199474146631871,
                4.626135363389335,
                7.984644648944923,
                9.065006747517675
            ]
        },
        {
            "name": "Logan Baxter",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.768371843504394,
                2.8614821421825494,
                6.363444527370169,
                9.579261021106314
            ]
        },
        {
            "name": "Todd Vega",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.1218166786757395,
                9.72542980162456,
                4.341118600606499,
                7.677557208349258
            ]
        },
        {
            "name": "Carmen Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.744876805315478,
                5.60038791005689,
                9.442686434094457,
                9.374712981451541
            ]
        },
        {
            "name": "Zachary Evans",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.7007670994555157,
                8.564996353738888,
                1.978549380711869,
                4.766617502059252
            ]
        },
        {
            "name": "Dawn Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.678450072154552,
                5.9288427280514195,
                4.5185012335615236,
                8.928142999036806
            ]
        },
        {
            "name": "Sarah Edwards",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.869752673899743,
                7.989717618476874,
                8.824010410721542,
                9.340541374354679
            ]
        },
        {
            "name": "Rachael Smith",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                4.0,
                9.0,
                1.0
            ]
        },
        {
            "name": "Dennis Baker",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.019319916723581458,
                5.164508956302449,
                4.886821016643274,
                5.2524885728748885
            ]
        },
        {
            "name": "Kendra Chung",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.783705540381154,
                7.3073223392181275,
                4.4340562303391975,
                7.886226734517016
            ]
        },
        {
            "name": "Justin Taylor",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.172591145241574,
                9.53147288645452,
                4.626030776970427,
                6.169760969670794
            ]
        },
        {
            "name": "Amy Spears",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                8.0,
                6.0,
                0.0
            ]
        },
        {
            "name": "Gary Ward",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.24890938558443323,
                7.679629517984169,
                5.275975037131301,
                9.338892290521501
            ]
        },
        {
            "name": "Dana Stone",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.148028737544701,
                8.723621549699129,
                0.5997372423828695,
                9.612358681908523
            ]
        },
        {
            "name": "Amanda Walker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.8799351081435285,
                8.965860793514791,
                8.342408149193062,
                7.575342514417037
            ]
        },
        {
            "name": "Tyrone Vega",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                3.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Thomas Walker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.579252743219987,
                7.466679043341335,
                7.795669077927845,
                7.684399687890546
            ]
        },
        {
            "name": "Anita Graham",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.954530125057605,
                3.337978986690597,
                7.01464151316096,
                9.730120473073354
            ]
        },
        {
            "name": "Megan Sloan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.5758762037518073,
                9.573749010193236,
                8.826872940132182,
                7.181410132858904
            ]
        },
        {
            "name": "Megan Jackson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                4.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Melanie Lopez",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.546997965421001,
                6.414384700487849,
                5.499960230114299,
                4.173268955998716
            ]
        },
        {
            "name": "Kayla Campos",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.608010083838434,
                3.491763874653187,
                3.1045434481235645,
                4.185517646741636
            ]
        },
        {
            "name": "Kelsey Leach",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.891478584068231,
                2.568389838418275,
                5.148733057188043,
                2.4957524258562818
            ]
        },
        {
            "name": "Karen Perez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.09367637096058,
                5.459358762374933,
                0.44544114118654377,
                5.297955582207178
            ]
        },
        {
            "name": "Molly Barber",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.1524443984557228,
                3.817707538590309,
                9.646628028342747,
                9.375569488318995
            ]
        },
        {
            "name": "Kevin Hawkins",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.731688507206835,
                9.652596414529318,
                8.088877493152099,
                6.069203610535119
            ]
        },
        {
            "name": "Victoria Eaton",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.617491711966317,
                9.055808847172342,
                0.5857346783040178,
                0.4545657150853835
            ]
        },
        {
            "name": "Ashley Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.693933474325739,
                0.8779594441356008,
                7.28101089105876,
                5.431085205792796
            ]
        },
        {
            "name": "Erin Stevenson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.05389700957755,
                4.489567035105076,
                2.5409671866297363,
                8.85405185714218
            ]
        },
        {
            "name": "Thomas Steele",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.330103204525646,
                2.826538329600311,
                2.0594263613280903,
                9.02887513512993
            ]
        },
        {
            "name": "Jennifer Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.246329191935835,
                7.407052778063684,
                4.525485501132664,
                5.816794077198987
            ]
        },
        {
            "name": "Debra Turner",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.38048120777569,
                1.3723813097307174,
                2.7797164175098525,
                2.3087249163333263
            ]
        },
        {
            "name": "Robert Lopez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.6275273726244124,
                1.2672967578466718,
                6.861916234725679,
                1.0487796508466611
            ]
        },
        {
            "name": "Anthony Yang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.94904750308817,
                5.286174274796494,
                4.821663933383721,
                9.785227867566782
            ]
        },
        {
            "name": "Shawn Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.105071849903376,
                9.148512358739772,
                4.644555555635096,
                2.949551145036028
            ]
        },
        {
            "name": "Joseph Koch",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.769379168316522,
                5.93257630660207,
                5.322313469390521,
                3.4870274928507423
            ]
        },
        {
            "name": "Travis Rodgers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                7.0,
                2.0,
                2.0
            ]
        },
        {
            "name": "Kathryn Perry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.934012864675826,
                5.7615465783152295,
                5.887735643582631,
                4.936901140394222
            ]
        },
        {
            "name": "Ashley Jackson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.790249404842589,
                1.4889163341919232,
                7.4134755002547195,
                9.842711025099183
            ]
        },
        {
            "name": "Chelsea Myers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                5.0,
                6.0
            ]
        },
        {
            "name": "Jonathon Casey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.745446303707894,
                5.209993565860015,
                9.597662914460013,
                7.590648806413096
            ]
        },
        {
            "name": "Robert Mason",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.870996178165823,
                3.7138470146424156,
                9.79391245890908,
                6.18400486472165
            ]
        },
        {
            "name": "Amanda Tucker",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.00625708608072,
                3.333739230376795,
                5.79953382318385,
                4.914255414717867
            ]
        },
        {
            "name": "Robin Soto",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                2.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Robert Nash",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.308737656080055,
                8.19765787789635,
                4.298876091025248,
                3.6125140582071085
            ]
        },
        {
            "name": "Daniel Walker",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                0.0,
                6.0,
                3.0
            ]
        },
        {
            "name": "Sarah Alvarez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.154492091506622,
                8.271200258045981,
                9.761617084175448,
                2.067026678947012
            ]
        },
        {
            "name": "Nicholas Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.8334756217892325,
                8.591701036715724,
                9.957547813164991,
                5.132260765066864
            ]
        },
        {
            "name": "Keith Sanchez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.2791347138342591,
                9.002835751846133,
                9.638878638383364,
                6.252500233695219
            ]
        },
        {
            "name": "Vanessa Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.264278742246418,
                3.6062766415567205,
                6.116626103988228,
                4.427861865525616
            ]
        },
        {
            "name": "Ernest Medina",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9223017594002716,
                8.901535477896122,
                1.5514741121251105,
                8.181578859998552
            ]
        },
        {
            "name": "Kevin Curry",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9053926893344837,
                2.1581322362969666,
                7.320955006593719,
                6.812655799595185
            ]
        },
        {
            "name": "Alex Harvey",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.6823402106476923,
                2.739405648293813,
                5.962693586761959,
                4.475047320970892
            ]
        },
        {
            "name": "Terri Gill",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.49805960413748,
                2.0430850196985673,
                3.3774060125494105,
                3.522079193693185
            ]
        },
        {
            "name": "Larry Short",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.560879901713321,
                8.056010015570603,
                2.2443803782294673,
                8.755770384674985
            ]
        },
        {
            "name": "Allison Garcia",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                8.0,
                0.0,
                3.0
            ]
        },
        {
            "name": "Amy Cook",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.2519783779762568,
                3.9241626925044057,
                5.010689413250312,
                7.604448476811387
            ]
        },
        {
            "name": "Paul Oliver",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.9517954499281855,
                4.723342469916511,
                9.42352815505255,
                2.8583006932266497
            ]
        },
        {
            "name": "Lori Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.279316519096982,
                9.456539156910651,
                8.94173203938705,
                4.806905019553399
            ]
        },
        {
            "name": "Justin Bishop",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.852568048400757,
                2.35275831026038,
                9.64715505480675,
                8.693252048938229
            ]
        },
        {
            "name": "Anne Bryant",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                1.0,
                0.0,
                4.0
            ]
        },
        {
            "name": "Ruth Blackburn",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.714411863791629,
                4.201573764457113,
                5.333327094594057,
                3.937824672718609
            ]
        },
        {
            "name": "Kyle Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.754658190607168,
                3.2528797600323482,
                4.8827588433068785,
                6.219046303210927
            ]
        },
        {
            "name": "Tiffany Reeves",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.657555596574001,
                9.312697668266221,
                7.564028948612799,
                6.276201866355372
            ]
        },
        {
            "name": "Daniel Wagner",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                4.0,
                1.0
            ]
        },
        {
            "name": "James Shaw",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.0655058343369126,
                9.748388360172285,
                8.955901336290045,
                8.231748663756052
            ]
        },
        {
            "name": "Pamela Woods",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.9661615374224417,
                1.0782277592147065,
                4.690284848190362,
                2.8490868423225897
            ]
        },
        {
            "name": "Tammy Wang",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Janet Parsons",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.25363582326027134,
                9.222446016898623,
                2.2929542712505007,
                9.291516414229298
            ]
        },
        {
            "name": "Scott Little",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                0.48650456883676924,
                4.4457691530774195,
                7.814638363164601,
                5.987348824281877
            ]
        },
        {
            "name": "Jason Hicks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.10525614188293,
                8.989926071478902,
                0.325099844201307,
                2.5588132180917356
            ]
        },
        {
            "name": "Destiny Hill",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Mary Rodriguez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                0.0,
                9.0,
                7.0
            ]
        },
        {
            "name": "James Luna",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                3.0,
                8.0
            ]
        },
        {
            "name": "Julie Scott",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.64200101611859,
                4.56008435675081,
                4.993346027769415,
                5.716076729660275
            ]
        },
        {
            "name": "Samuel King",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.090297608503233,
                7.39744992578008,
                6.847594845128593,
                8.62187148867902
            ]
        },
        {
            "name": "Tracy Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                2.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Timothy Henson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                1.0,
                6.0
            ]
        },
        {
            "name": "Casey Howard",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.542007980593093,
                7.162667585867659,
                6.883000824284338,
                3.757388989224417
            ]
        },
        {
            "name": "Misty West",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                7.034043426010586,
                3.357375754729739,
                2.520873753878963,
                2.5252849125272947
            ]
        },
        {
            "name": "Matthew Thomas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.411943169745436,
                9.950079241145795,
                7.089952418872714,
                7.269399061442895
            ]
        },
        {
            "name": "Daniel Simpson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "Ethan Ramsey",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.2432529926651403,
                7.780571470700048,
                7.463477814237695,
                2.273345201025215
            ]
        },
        {
            "name": "Marilyn Tyler",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                3.0,
                1.0,
                7.0
            ]
        },
        {
            "name": "Keith Jones",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                5.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Gregory Lopez",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.7679467482739877,
                2.2248524581842446,
                4.346712815955472,
                7.482996041990142
            ]
        },
        {
            "name": "Rebecca Green",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.339827923605761,
                3.989102834572489,
                6.292599248546401,
                2.8942764524331683
            ]
        },
        {
            "name": "Mary Garcia",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.162255566028203,
                7.079027134535457,
                3.190037420948631,
                5.2800341759224265
            ]
        },
        {
            "name": "Brian Walker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.396916445920928,
                3.1282329865387783,
                5.309888241403016,
                8.056824457930553
            ]
        },
        {
            "name": "Tonya Butler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.3346051862003567,
                7.721482208212067,
                7.1008882922040915,
                3.88337075362075
            ]
        },
        {
            "name": "Adrian Hill",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.972400892267434,
                8.60805010478658,
                6.415327232554149,
                0.5875475952315746
            ]
        },
        {
            "name": "Derrick Hunt",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.670501954787182,
                1.097850001930922,
                9.364677522801308,
                3.6846942818197466
            ]
        },
        {
            "name": "Michael Gaines",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                0.0,
                6.0
            ]
        },
        {
            "name": "John Edwards",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                5.0,
                0.0,
                3.0
            ]
        },
        {
            "name": "Jesse Nelson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.8007089126922584,
                3.265261387126711,
                9.740721325110481,
                2.800097751119655
            ]
        },
        {
            "name": "Bobby Mcdaniel",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.728900265361441,
                8.230987155332187,
                3.6858794713888274,
                9.34925470613855
            ]
        },
        {
            "name": "Kim Baker",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.963079392814498,
                8.115272778797067,
                2.8585892015479257,
                5.234937383965894
            ]
        },
        {
            "name": "Lisa Robinson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8111387026272243,
                9.38643752844577,
                4.959372652624126,
                6.163430422506467
            ]
        },
        {
            "name": "Lance Warren",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.032943724771661,
                8.381367573719336,
                5.645042022786768,
                4.712843836734111
            ]
        },
        {
            "name": "Jeffrey Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.899294622793712,
                8.194359432972952,
                6.124826347635272,
                0.8106295584058343
            ]
        },
        {
            "name": "Jason Fuentes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                1.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Carrie Lopez",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                6.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Rachel Cortez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Cindy Patel",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.865852142662375,
                7.16010395876677,
                8.182099677316383,
                8.656756414399794
            ]
        },
        {
            "name": "Anna Turner",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.608535114813985,
                1.6585902536274946,
                9.154837504276266,
                7.157131764705427
            ]
        },
        {
            "name": "Andrea Ryan",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.558103610306088,
                5.295674682189747,
                9.865796625773868,
                7.516593609493791
            ]
        },
        {
            "name": "Heidi Bell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.93081931710672,
                8.938687561495541,
                9.127707304930123,
                5.356038913624539
            ]
        },
        {
            "name": "Tammy Lewis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.5029739070771715,
                9.886355330308216,
                7.1905678495437675,
                3.8014723148325618
            ]
        },
        {
            "name": "Rebecca Ho",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.944206077152537,
                5.941065288379022,
                2.3003044530952548,
                5.730943629141148
            ]
        },
        {
            "name": "Victoria White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.023524109076034,
                5.465045030727897,
                8.429367747814993,
                9.153031256476147
            ]
        },
        {
            "name": "Jeffery Ware",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.222967170274627,
                3.5520108922996063,
                1.3415455984438767,
                9.38943757772787
            ]
        },
        {
            "name": "Justin Clay",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.210960187959605,
                9.297359557131083,
                3.778529927189031,
                1.3533535481934302
            ]
        },
        {
            "name": "Jill Douglas",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                5.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Thomas Lewis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.83587998103676,
                9.116061197410042,
                4.447577379567147,
                9.000554225603079
            ]
        },
        {
            "name": "Michael Miller",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.678058455286079,
                7.667964562255161,
                9.501111666554733,
                3.3761292454547305
            ]
        },
        {
            "name": "Ryan Taylor",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                6.0,
                7.0,
                2.0
            ]
        },
        {
            "name": "Sharon Glenn",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.131165002667492,
                5.111153864456299,
                1.0453996214194312,
                5.259905852227313
            ]
        },
        {
            "name": "Susan Curtis",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                6.0,
                5.0,
                7.0
            ]
        },
        {
            "name": "Mary Logan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.858063723075427,
                5.932122548703546,
                8.066058830324694,
                2.060077709292694
            ]
        },
        {
            "name": "Timothy Taylor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.119134586483854,
                9.087472761733991,
                7.51820284369537,
                2.8180779240462517
            ]
        },
        {
            "name": "Jason Watkins",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                5.0,
                3.0
            ]
        },
        {
            "name": "Patricia Dunn",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.702855067978013,
                4.983692313832763,
                2.200249357070689,
                8.090157594058022
            ]
        },
        {
            "name": "Annette Hodges",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.122786380616294,
                9.56737108723104,
                4.560686880432195,
                8.42667299652916
            ]
        },
        {
            "name": "Kirk Jones",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.094157965240505,
                8.493782465741313,
                8.258847758864077,
                1.3966980258164239
            ]
        },
        {
            "name": "Charles Day",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.048524845446028,
                8.58403949733839,
                8.55247572587677,
                5.1985112981268475
            ]
        },
        {
            "name": "Marco Smith",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                9.0,
                9.0,
                5.0,
                4.0
            ]
        },
        {
            "name": "William Norman",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.47460173752465,
                8.519203253256123,
                8.64416487750739,
                4.738933749607702
            ]
        },
        {
            "name": "Karen Turner",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.8433426701271562,
                3.223132287195421,
                7.687123271602319,
                0.17962546482240274
            ]
        },
        {
            "name": "Monica Walsh",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                8.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "John Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                0.0,
                0.0,
                5.0
            ]
        },
        {
            "name": "Alexis Douglas",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                4.0,
                5.0,
                4.0
            ]
        },
        {
            "name": "Julie Dawson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.7233826724014265,
                6.681258258202838,
                2.249234565392959,
                9.844150709065293
            ]
        },
        {
            "name": "Frank Jordan",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.69069129072574,
                6.9184419124702226,
                5.535547551143464,
                6.903551461171427
            ]
        },
        {
            "name": "Jordan Chang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.1731949749797392,
                7.4053410989490605,
                6.346937508774147,
                7.067528640799864
            ]
        },
        {
            "name": "Lisa Baker",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                8.0,
                8.0,
                6.0
            ]
        },
        {
            "name": "Michael Cline",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.6597288063205,
                8.53186508408103,
                8.483854477365172,
                6.296007715608249
            ]
        },
        {
            "name": "Kevin Garza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.897143678600777,
                6.767712510001066,
                9.003227786921842,
                3.3437691076553353
            ]
        },
        {
            "name": "Jessica Nelson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                7.0,
                9.0,
                4.0
            ]
        },
        {
            "name": "Lisa Marquez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.1694189988412083,
                9.492185935942107,
                7.534456362837471,
                9.94182485217789
            ]
        },
        {
            "name": "Tanya Flores",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                1.0,
                1.0,
                8.0
            ]
        },
        {
            "name": "Melvin Pierce",
            "city": 0,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                5.0,
                6.0,
                6.0,
                9.0
            ]
        },
        {
            "name": "David Holden",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.955199441251426,
                9.557841794273083,
                4.700897065746524,
                0.9074296839348788
            ]
        },
        {
            "name": "Kari Navarro",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                4.0,
                6.0,
                4.0
            ]
        },
        {
            "name": "Anthony Reyes",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.0959887873863,
                5.641517837210028,
                7.147912139288232,
                0.5263215848845031
            ]
        },
        {
            "name": "John Griffith",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.589747456058186,
                2.6388760738024937,
                3.6895979406296213,
                2.6017664822848694
            ]
        },
        {
            "name": "Amanda Ruiz",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                7.0,
                5.0,
                5.0
            ]
        },
        {
            "name": "Jeremy Perez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                4.0,
                5.0,
                2.0
            ]
        },
        {
            "name": "Thomas Craig",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                7.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Donna Compton",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.206451591898166,
                6.0048442137620714,
                5.856161554377113,
                2.552549712427534
            ]
        },
        {
            "name": "Kevin Mcbride",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.780749068820869,
                6.854293357288074,
                5.362188808875058,
                6.605389376905116
            ]
        },
        {
            "name": "Thomas Mendoza",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.645648766986065,
                1.1918997797751172,
                5.001170405975,
                6.486300994744307
            ]
        },
        {
            "name": "Brenda Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.490811138294597,
                4.882051217344193,
                6.798988579389307,
                4.05990868398723
            ]
        },
        {
            "name": "Amanda Davis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.837321294624332,
                2.9334926888476938,
                4.061953283819965,
                8.809860655181454
            ]
        },
        {
            "name": "Debra Pacheco",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                8.0,
                0.0,
                9.0
            ]
        },
        {
            "name": "Hannah Duffy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.793110755549387,
                9.153011043051473,
                3.8671630379532784,
                0.4613847005670928
            ]
        },
        {
            "name": "Adam Scott",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.400165193586094,
                4.053082525459576,
                5.205122773416035,
                3.1519170438335156
            ]
        },
        {
            "name": "Deborah Ortega",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.972520474793744,
                7.474349583490398,
                6.3404211405777575,
                4.789573666986151
            ]
        },
        {
            "name": "John Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.738101603911919,
                5.715423715909861,
                6.264407038014593,
                5.430542421243483
            ]
        },
        {
            "name": "Jacob Wilson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                6.40117572835177,
                2.706234073569912,
                2.6572232196069887,
                5.150211655026931
            ]
        },
        {
            "name": "Paul Harris",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.32878749163857,
                1.635500278023021,
                3.211686935511944,
                1.437920738945195
            ]
        },
        {
            "name": "Tracy Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.51682742639371,
                8.512984409238602,
                6.888314183311479,
                7.575250581536897
            ]
        },
        {
            "name": "Dana Martin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.6291770955840614,
                7.365156040840013,
                9.227709313059751,
                6.617139483794592
            ]
        },
        {
            "name": "Dana Holland",
            "city": 1,
            "color": "blue",
            "empl": 1,
            "qualifications": [
                3.0,
                8.0,
                9.0,
                6.0
            ]
        },
        {
            "name": "Misty Osborn",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                4.0,
                5.0,
                2.0
            ]
        },
        {
            "name": "Sara Johnson",
            "city": 0,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.095835303342299,
                1.636186731650069,
                2.8305381914102186,
                3.372315585635441
            ]
        },
        {
            "name": "Robert Harris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.321575046739886,
                3.4159662208606134,
                8.866141241204177,
                8.79397453238507
            ]
        },
        {
            "name": "Margaret Dean",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.796573947109003,
                9.350703957253545,
                7.600774325001965,
                6.42665565012268
            ]
        },
        {
            "name": "Cindy Potter",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                4.0,
                1.0,
                7.0
            ]
        },
        {
            "name": "Thomas Ellis",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.949850874122443,
                9.089384906238866,
                6.457672373273264,
                8.017741035262617
            ]
        },
        {
            "name": "David Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.302249061666815,
                6.491399148315925,
                2.0910906065978723,
                4.7927784165113865
            ]
        },
        {
            "name": "Daniel Barber",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.5351089683446535,
                5.853756530858924,
                6.142199407126975,
                9.719337566261977
            ]
        },
        {
            "name": "Hannah Hall",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.070342635913816,
                6.4867585929869644,
                8.423693892098731,
                8.307176873047016
            ]
        },
        {
            "name": "Breanna Mora",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.344382533581953,
                6.211661966694566,
                7.218206931546197,
                4.347166080819784
            ]
        },
        {
            "name": "Lisa Hill",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.724493033498672,
                7.124889203790535,
                3.5172891989263477,
                9.023989219798281
            ]
        },
        {
            "name": "David Moore",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.329020723719743,
                5.804243583529462,
                9.859779729272416,
                7.281624121775387
            ]
        },
        {
            "name": "Kristin Morris",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.462399842373551,
                2.494333569904057,
                9.237343618496457,
                8.482811253069954
            ]
        },
        {
            "name": "Shannon Owens",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.082250931474332,
                6.667822152659416,
                6.794909849806594,
                2.928300664767656
            ]
        },
        {
            "name": "Don Patterson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.771714594307037,
                8.14096136428489,
                6.74501716389825,
                4.488582741352384
            ]
        },
        {
            "name": "Laura Arellano",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                3.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Angie Martinez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                6.0,
                2.0,
                8.0,
                1.0
            ]
        },
        {
            "name": "Olivia Tran",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.6217146902613875,
                7.2113661137133995,
                0.9890480829844532,
                4.537485049020061
            ]
        },
        {
            "name": "Matthew Jones",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.34271175155674,
                8.021389583443124,
                7.223642598269427,
                9.486745310756692
            ]
        },
        {
            "name": "Eric Mckinney",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                0.9759535272757093,
                4.980939640175111,
                6.263115454726541,
                3.606347857262049
            ]
        },
        {
            "name": "Joshua Rogers",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                0.0,
                4.0,
                3.0
            ]
        },
        {
            "name": "Karen Cole",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                7.0,
                3.0,
                1.0
            ]
        },
        {
            "name": "Crystal Lopez",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.0451867944616307,
                8.164268412634533,
                6.463666208494745,
                4.0645984595544125
            ]
        },
        {
            "name": "Melissa Morgan",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                3.0,
                6.0,
                7.0
            ]
        },
        {
            "name": "Mark Warner",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                6.0,
                9.0
            ]
        },
        {
            "name": "Michael Ibarra",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.5359938180635593,
                4.239346548993816,
                9.125990290969755,
                1.9519494828736264
            ]
        },
        {
            "name": "Elaine Johnson",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.2047935100053193,
                4.412780973801279,
                5.767889499222813,
                1.4912210249116484
            ]
        },
        {
            "name": "Anna Ferguson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                1.0,
                9.0,
                2.0
            ]
        },
        {
            "name": "Kelly Rios",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                3.0,
                0.0,
                8.0
            ]
        },
        {
            "name": "Kevin Woodard",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.817388281173882,
                3.076244835047997,
                3.8705791348392755,
                9.964341957598133
            ]
        },
        {
            "name": "Donna Edwards",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.931398303546587,
                5.808499931141662,
                9.3766295084532,
                5.25149326195095
            ]
        },
        {
            "name": "Kerry Ayala",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                0.0,
                3.0,
                6.0
            ]
        },
        {
            "name": "Nicholas Bell",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                9.0,
                1.0,
                2.0
            ]
        },
        {
            "name": "Michael Olson",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.33141402483401,
                2.1691049637961646,
                9.38171850910715,
                4.395874259865514
            ]
        },
        {
            "name": "Sierra Marks",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                6.0,
                1.0,
                0.0
            ]
        },
        {
            "name": "Stephen Welch",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                2.812881511096394,
                1.141642778799632,
                7.249626713517328,
                3.8145619186668585
            ]
        },
        {
            "name": "Cheryl Price",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                2.0,
                2.0,
                6.0
            ]
        },
        {
            "name": "Natalie Kelley",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                3.0,
                1.0,
                3.0
            ]
        },
        {
            "name": "Justin Cruz",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                0.0,
                4.0,
                5.0
            ]
        },
        {
            "name": "Mary Myers",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.981302938824805,
                8.488483246638676,
                4.101655438536319,
                8.0704426239187
            ]
        },
        {
            "name": "Francis Zhang",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.705787289456999,
                9.73635743369191,
                4.059636309303168,
                7.354545013930257
            ]
        },
        {
            "name": "Beverly Brown",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.74728369598038,
                6.524768070435108,
                5.107593343726,
                5.440170463976238
            ]
        },
        {
            "name": "Kristen Mclean",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.613644270498252,
                6.704086894855184,
                9.535251703800878,
                9.521376109716993
            ]
        },
        {
            "name": "Barbara Hall",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.899746755238072,
                8.02651798876014,
                2.4589688092464117,
                3.0099385675991646
            ]
        },
        {
            "name": "Daniel Salas",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.043348025561265,
                7.224916913620145,
                7.118538888776344,
                1.4126456813048374
            ]
        },
        {
            "name": "John Adams",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.8406422998538052,
                9.069207007505366,
                9.587834891895907,
                4.306709331062189
            ]
        },
        {
            "name": "Scott Griffin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.610278505032543,
                7.397587560955908,
                8.362688129449847,
                8.311970020362892
            ]
        },
        {
            "name": "Aaron Kane DDS",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.722742829308487,
                5.696546007392404,
                3.5947070438426505,
                7.682748068113115
            ]
        },
        {
            "name": "Bruce Anderson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.8616383767084723,
                7.14791166551905,
                4.470027057990627,
                8.630876350637417
            ]
        },
        {
            "name": "Gregory Powell",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.489499004516368,
                8.280714343906233,
                6.927471295081017,
                6.092519382670401
            ]
        },
        {
            "name": "Brandon Bray",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.150309906141285,
                8.177421104922466,
                3.5698589640943545,
                6.8213931790965745
            ]
        },
        {
            "name": "Colin Stone",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.5755736947434453,
                4.693828316410857,
                6.8119746731939035,
                8.064853370842629
            ]
        },
        {
            "name": "Hailey Wright",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.31865734438043,
                0.17275021303618657,
                7.188273388639238,
                9.170701025558868
            ]
        },
        {
            "name": "David Mueller",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                8.0,
                3.0
            ]
        },
        {
            "name": "Rebecca Wells",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.607300685562606,
                7.395075109511838,
                1.2196814770869133,
                9.634934275566323
            ]
        },
        {
            "name": "Keith Johnson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.827416578316067,
                6.966603488763507,
                6.975923708551783,
                8.763156910072945
            ]
        },
        {
            "name": "Kaitlyn Green",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                5.0,
                1.0,
                8.0
            ]
        },
        {
            "name": "Melanie Clark",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.172484099500181,
                8.163391686568453,
                3.739886369495722,
                8.606989797410293
            ]
        },
        {
            "name": "Charles Thomas",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                0.0,
                6.0,
                5.0
            ]
        },
        {
            "name": "Rachel Smith",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                6.0,
                3.0,
                9.0
            ]
        },
        {
            "name": "Wesley Briggs",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                5.0,
                3.0,
                7.0
            ]
        },
        {
            "name": "Bradley Combs",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                9.0,
                7.0,
                5.0
            ]
        },
        {
            "name": "Jennifer Mata",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                1.0,
                3.0,
                8.0
            ]
        },
        {
            "name": "Kristin Pierce",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.763876211768343,
                5.649873425272984,
                6.015970221822596,
                9.924925263798986
            ]
        },
        {
            "name": "Monica Jenkins",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                9.0,
                7.0,
                9.0,
                0.0
            ]
        },
        {
            "name": "Richard Ortega",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                4.0,
                4.0,
                2.0
            ]
        },
        {
            "name": "Rebecca Parker",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.858924846231957,
                4.152722708389634,
                4.002318748669138,
                7.960504412213356
            ]
        },
        {
            "name": "Kenneth Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.835761814639602,
                5.31770924465471,
                7.61289820240496,
                5.35224127976528
            ]
        },
        {
            "name": "Katie Bennett",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.301588229392462,
                2.2245629880423556,
                8.123261809315617,
                4.202080093688477
            ]
        },
        {
            "name": "Becky Holland",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.242610667808052,
                6.661291757340917,
                7.975259002154739,
                0.7817058271635877
            ]
        },
        {
            "name": "Michael Morris",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                2.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Ryan Gallagher",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.784794121249672,
                6.8588747141491435,
                4.794910139360604,
                6.98467423946226
            ]
        },
        {
            "name": "Zachary Evans",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.762132394943105,
                9.737419795426183,
                5.466039476776469,
                2.59485966038897
            ]
        },
        {
            "name": "Raven Elliott",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.263523610271179,
                7.060564145699394,
                5.285438926086501,
                4.444513195476902
            ]
        },
        {
            "name": "Patty Scott",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.978655175224598,
                0.6739131463812332,
                6.179743419141444,
                2.383439356357346
            ]
        },
        {
            "name": "Jason West",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                3.0,
                9.0,
                0.0
            ]
        },
        {
            "name": "Matthew Liu",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                3.0,
                0.0,
                7.0
            ]
        },
        {
            "name": "Danny Bennett",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                2.289745439029069,
                8.603779418203922,
                6.8984865751996125,
                3.8531480565447875
            ]
        },
        {
            "name": "Shawn Gross MD",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.92864302444862,
                7.700150342653357,
                9.879899546497237,
                6.934531090471989
            ]
        },
        {
            "name": "Jason Phillips",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                2.0,
                4.0,
                6.0
            ]
        },
        {
            "name": "Taylor Jackson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.26857124820361,
                7.085593961504943,
                9.66484016688743,
                8.561059095381317
            ]
        },
        {
            "name": "Mary Sutton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.926977349206648,
                9.73070028008475,
                4.13101821147974,
                9.157975110857034
            ]
        },
        {
            "name": "Denise Parker",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                8.0,
                8.0,
                4.0
            ]
        },
        {
            "name": "Robert Wall",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                6.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Raymond Berry",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.676274484298247,
                3.5349082937924843,
                5.286771033743049,
                8.891366130630216
            ]
        },
        {
            "name": "Curtis Mason",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.180613348635898,
                1.2560609153955862,
                7.0868896699268005,
                6.779850599578916
            ]
        },
        {
            "name": "Karla Lawrence",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.580247391122478,
                5.472546208185162,
                6.064978801315385,
                7.528665896541172
            ]
        },
        {
            "name": "Kimberly Lee",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.833595851714323,
                6.262557742221019,
                0.30347943438840197,
                6.19175308017037
            ]
        },
        {
            "name": "Amber Owen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.852214621146158,
                6.953072802686943,
                7.970208708890025,
                6.016103974002533
            ]
        },
        {
            "name": "Tyrone Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                1.0,
                2.0,
                6.0,
                7.0
            ]
        },
        {
            "name": "Brandon Floyd",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                0.0,
                4.0,
                6.0
            ]
        },
        {
            "name": "Jonathan White",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                6.019079845555408,
                9.747893321024298,
                2.88274895246718,
                5.172823608060457
            ]
        },
        {
            "name": "David Larson",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.03798519454814,
                8.791223075002009,
                0.9226230872890595,
                6.8604733932879425
            ]
        },
        {
            "name": "Diane Massey",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                5.941039807260529,
                7.994376659419624,
                0.24670877607211847,
                2.3396600741412863
            ]
        },
        {
            "name": "Adam Boyer",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                7.0,
                2.0,
                3.0,
                0.0
            ]
        },
        {
            "name": "Ebony Cooper",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.922998183238928,
                2.281507862444684,
                6.282126914242961,
                8.249337637449685
            ]
        },
        {
            "name": "Andrew Forbes",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                0.0,
                1.0,
                0.0,
                2.0
            ]
        },
        {
            "name": "Michael Snyder",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.2447365680837885,
                4.955437838003645,
                8.94853983935905,
                7.7140351931333475
            ]
        },
        {
            "name": "Susan Ellison",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                3.558894501512762,
                0.14309091639637417,
                3.4218356128231706,
                3.4570650611625062
            ]
        },
        {
            "name": "Edward Lewis",
            "city": 1,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                4.0,
                3.0,
                3.0
            ]
        },
        {
            "name": "Sandra Martin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                3.98495423507538,
                5.499538775024354,
                9.855041794386436,
                6.798030749701356
            ]
        },
        {
            "name": "Allison Fowler",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.129048521304271,
                3.5363065046024396,
                8.972734413883792,
                8.163021924306367
            ]
        },
        {
            "name": "Victor Miller",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.577574197871842,
                2.2383369096205006,
                9.878424594453039,
                5.0541115852872585
            ]
        },
        {
            "name": "Edwin Smith",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.800716360681067,
                5.854506874787866,
                8.965255252596512,
                4.305493688807333
            ]
        },
        {
            "name": "Meghan Mckee",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                8.0,
                3.0,
                1.0,
                1.0
            ]
        },
        {
            "name": "Karen Brooks",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.677886635802652,
                4.463981717379248,
                7.448337669918623,
                9.600264873333805
            ]
        },
        {
            "name": "Mark Jimenez",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                4.0,
                2.0,
                2.0,
                5.0
            ]
        },
        {
            "name": "Joseph Proctor",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.2947329325137815,
                6.05780058718122,
                4.244268548397926,
                8.119233954315249
            ]
        },
        {
            "name": "Jason Conrad",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                4.735119436344688,
                5.190619764043689,
                1.386520212478426,
                1.371649866251261
            ]
        },
        {
            "name": "Elizabeth Roy",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.176816293031482,
                2.670759920142828,
                6.824781451818456,
                5.841923528697327
            ]
        },
        {
            "name": "Joseph Flores",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                9.017559459832903,
                7.857145281600985,
                3.895311092269252,
                6.7698773499740685
            ]
        },
        {
            "name": "Mark Johnson",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                2.0,
                6.0,
                2.0,
                0.0
            ]
        },
        {
            "name": "Emily Garcia",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                5.068003481941677,
                7.193928488673888,
                5.193702287890556,
                7.660022768102435
            ]
        },
        {
            "name": "Timothy Green",
            "city": 0,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                7.17707643282866,
                2.2163519226117385,
                4.382137497779241,
                6.091245702052472
            ]
        },
        {
            "name": "Carolyn Allen",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                8.847596371620751,
                9.311119542331772,
                8.714572667819686,
                7.033298350440209
            ]
        },
        {
            "name": "Keith Bowen",
            "city": 1,
            "color": "orange",
            "empl": 0,
            "qualifications": [
                1.8978189028411934,
                8.5609726643483,
                2.6147243214653977,
                2.820738840520292
            ]
        },
        {
            "name": "Jeffrey Bates",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                3.0,
                4.0,
                0.0,
                6.0
            ]
        },
        {
            "name": "Stacey Horton",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                4.402543025796328,
                2.6226402977900714,
                6.713791446167189,
                5.3765652661240315
            ]
        },
        {
            "name": "Jessica Austin",
            "city": 1,
            "color": "orange",
            "empl": 1,
            "qualifications": [
                1.0634608405783894,
                6.1814479309147385,
                3.166817858036852,
                7.9379654782586195
            ]
        },
        {
            "name": "David Brown",
            "city": 0,
            "color": "blue",
            "empl": 0,
            "qualifications": [
                5.0,
                1.0,
                9.0,
                3.0
            ]
        }
    ]
}